"use strict";var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}; /*!
                                                                                                                                                                                                                                                                                        * Masonry PACKAGED v4.2.2
                                                                                                                                                                                                                                                                                        * Cascading grid layout library
                                                                                                                                                                                                                                                                                        * https://masonry.desandro.com
                                                                                                                                                                                                                                                                                        * MIT License
                                                                                                                                                                                                                                                                                        * by David DeSandro
                                                                                                                                                                                                                                                                                        */

!function (t, e) {
	"function" == typeof define && define.amd ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
		return e(t, i);
	}) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(t, require("jquery")) : t.jQueryBridget = e(t, t.jQuery);
}(window, function (t, e) {
	"use strict";

	function i(i, r, a) {
		function h(t, e, n) {
			var o,r = "$()." + i + '("' + e + '")';
			return t.each(function (t, h) {
				var u = a.data(h, i);
				if (!u) return void s(i + " not initialized. Cannot call methods, i.e. " + r);
				var d = u[e];
				if (!d || "_" == e.charAt(0)) return void s(r + " is not a valid method");
				var l = d.apply(u, n);
				o = void 0 === o ? l : o;
			}), void 0 !== o ? o : t;
		}

		function u(t, e) {
			t.each(function (t, n) {
				var o = a.data(n, i);
				o ? (o.option(e), o._init()) : (o = new r(n, e), a.data(n, i, o));
			});
		}
		a = a || e || t.jQuery, a && (r.prototype.option || (r.prototype.option = function (t) {
			a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
		}), a.fn[i] = function (t) {
			if ("string" == typeof t) {
				var e = o.call(arguments, 1);
				return h(this, t, e);
			}
			return u(this, t), this;
		}, n(a));
	}

	function n(t) {
		!t || t && t.bridget || (t.bridget = i);
	}
	var o = Array.prototype.slice,
	r = t.console,
	s = "undefined" == typeof r ? function () {} : function (t) {
		r.error(t);
	};
	return n(e || t.jQuery), i;
}),
function (t, e) {
	"function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e() : t.EvEmitter = e();
}("undefined" != typeof window ? window : undefined, function () {
	function t() {}
	var e = t.prototype;
	return e.on = function (t, e) {
		if (t && e) {
			var i = this._events = this._events || {},
			n = i[t] = i[t] || [];
			return -1 == n.indexOf(e) && n.push(e), this;
		}
	}, e.once = function (t, e) {
		if (t && e) {
			this.on(t, e);
			var i = this._onceEvents = this._onceEvents || {},
			n = i[t] = i[t] || {};
			return n[e] = !0, this;
		}
	}, e.off = function (t, e) {
		var i = this._events && this._events[t];
		if (i && i.length) {
			var n = i.indexOf(e);
			return -1 != n && i.splice(n, 1), this;
		}
	}, e.emitEvent = function (t, e) {
		var i = this._events && this._events[t];
		if (i && i.length) {
			i = i.slice(0), e = e || [];
			for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
				var r = i[o],
				s = n && n[r];
				s && (this.off(t, r), delete n[r]), r.apply(this, e);
			}
			return this;
		}
	}, e.allOff = function () {
		delete this._events, delete this._onceEvents;
	}, t;
}),
function (t, e) {
	"function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e() : t.getSize = e();
}(window, function () {
	"use strict";

	function t(t) {
		var e = parseFloat(t),
		i = -1 == t.indexOf("%") && !isNaN(e);
		return i && e;
	}

	function e() {}

	function i() {
		for (var t = {
			width: 0,
			height: 0,
			innerWidth: 0,
			innerHeight: 0,
			outerWidth: 0,
			outerHeight: 0 },
		e = 0; u > e; e++) {
			var i = h[e];
			t[i] = 0;
		}
		return t;
	}

	function n(t) {
		var e = getComputedStyle(t);
		return e || a("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
	}

	function o() {
		if (!d) {
			d = !0;
			var e = document.createElement("div");
			e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
			var i = document.body || document.documentElement;
			i.appendChild(e);
			var o = n(e);
			s = 200 == Math.round(t(o.width)), r.isBoxSizeOuter = s, i.removeChild(e);
		}
	}

	function r(e) {
		if (o(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == (typeof e === "undefined" ? "undefined" : _typeof(e)) && e.nodeType) {
			var r = n(e);
			if ("none" == r.display) return i();
			var a = {};
			a.width = e.offsetWidth, a.height = e.offsetHeight;
			for (var d = a.isBorderBox = "border-box" == r.boxSizing, l = 0; u > l; l++) {
				var c = h[l],
				f = r[c],
				m = parseFloat(f);
				a[c] = isNaN(m) ? 0 : m;
			}
			var p = a.paddingLeft + a.paddingRight,
			g = a.paddingTop + a.paddingBottom,
			y = a.marginLeft + a.marginRight,
			v = a.marginTop + a.marginBottom,
			_ = a.borderLeftWidth + a.borderRightWidth,
			z = a.borderTopWidth + a.borderBottomWidth,
			E = d && s,
			b = t(r.width);
			b !== !1 && (a.width = b + (E ? 0 : p + _));
			var x = t(r.height);
			return x !== !1 && (a.height = x + (E ? 0 : g + z)), a.innerWidth = a.width - (p + _), a.innerHeight = a.height - (g + z), a.outerWidth = a.width + y, a.outerHeight = a.height + v, a;
		}
	}
	var s,a = "undefined" == typeof console ? e : function (t) {
		console.error(t);
	},
	h = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
	u = h.length,
	d = !1;
	return r;
}),
function (t, e) {
	"use strict";
	"function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e() : t.matchesSelector = e();
}(window, function () {
	"use strict";
	var t = function () {
		var t = window.Element.prototype;
		if (t.matches) return "matches";
		if (t.matchesSelector) return "matchesSelector";
		for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
			var n = e[i],
			o = n + "MatchesSelector";
			if (t[o]) return o;
		}
	}();
	return function (e, i) {
		return e[t](i);
	};
}),
function (t, e) {
	"function" == typeof define && define.amd ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
		return e(t, i);
	}) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(t, require("desandro-matches-selector")) : t.fizzyUIUtils = e(t, t.matchesSelector);
}(window, function (t, e) {
	var i = {};
	i.extend = function (t, e) {
		for (var i in e) {t[i] = e[i];}
		return t;
	}, i.modulo = function (t, e) {
		return (t % e + e) % e;
	};
	var n = Array.prototype.slice;
	i.makeArray = function (t) {
		if (Array.isArray(t)) return t;
		if (null === t || void 0 === t) return [];
		var e = "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "number" == typeof t.length;
		return e ? n.call(t) : [t];
	}, i.removeFrom = function (t, e) {
		var i = t.indexOf(e);-1 != i && t.splice(i, 1);
	}, i.getParent = function (t, i) {
		for (; t.parentNode && t != document.body;) {
			if (t = t.parentNode, e(t, i)) return t;}
	}, i.getQueryElement = function (t) {
		return "string" == typeof t ? document.querySelector(t) : t;
	}, i.handleEvent = function (t) {
		var e = "on" + t.type;
		this[e] && this[e](t);
	}, i.filterFindElements = function (t, n) {
		t = i.makeArray(t);
		var o = [];
		return t.forEach(function (t) {
			if (t instanceof HTMLElement) {
				if (!n) return void o.push(t);
				e(t, n) && o.push(t);
				for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) {o.push(i[r]);}
			}
		}), o;
	}, i.debounceMethod = function (t, e, i) {
		i = i || 100;
		var n = t.prototype[e],
		o = e + "Timeout";
		t.prototype[e] = function () {
			var t = this[o];
			clearTimeout(t);
			var e = arguments,
			r = this;
			this[o] = setTimeout(function () {
				n.apply(r, e), delete r[o];
			}, i);
		};
	}, i.docReady = function (t) {
		var e = document.readyState;
		"complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
	}, i.toDashed = function (t) {
		return t.replace(/(.)([A-Z])/g, function (t, e, i) {
			return e + "-" + i;
		}).toLowerCase();
	};
	var o = t.console;
	return i.htmlInit = function (e, n) {
		i.docReady(function () {
			var r = i.toDashed(n),
			s = "data-" + r,
			a = document.querySelectorAll("[" + s + "]"),
			h = document.querySelectorAll(".js-" + r),
			u = i.makeArray(a).concat(i.makeArray(h)),
			d = s + "-options",
			l = t.jQuery;
			u.forEach(function (t) {
				var i,r = t.getAttribute(s) || t.getAttribute(d);
				try {
					i = r && JSON.parse(r);
				} catch (a) {
					return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + a));
				}
				var h = new e(t, i);
				l && l.data(t, n, h);
			});
		});
	}, i;
}),
function (t, e) {
	"function" == typeof define && define.amd ? define("outlayer/item", ["ev-emitter/ev-emitter", "get-size/get-size"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(require("ev-emitter"), require("get-size")) : (t.Outlayer = {}, t.Outlayer.Item = e(t.EvEmitter, t.getSize));
}(window, function (t, e) {
	"use strict";

	function i(t) {
		for (var e in t) {return !1;}
		return e = null, !0;
	}

	function n(t, e) {
		t && (this.element = t, this.layout = e, this.position = {
			x: 0,
			y: 0 },
		this._create());
	}

	function o(t) {
		return t.replace(/([A-Z])/g, function (t) {
			return "-" + t.toLowerCase();
		});
	}
	var r = document.documentElement.style,
	s = "string" == typeof r.transition ? "transition" : "WebkitTransition",
	a = "string" == typeof r.transform ? "transform" : "WebkitTransform",
	h = {
		WebkitTransition: "webkitTransitionEnd",
		transition: "transitionend" }[
	s],
	u = {
		transform: a,
		transition: s,
		transitionDuration: s + "Duration",
		transitionProperty: s + "Property",
		transitionDelay: s + "Delay" },

	d = n.prototype = Object.create(t.prototype);
	d.constructor = n, d._create = function () {
		this._transn = {
			ingProperties: {},
			clean: {},
			onEnd: {} },
		this.css({
			position: "absolute" });

	}, d.handleEvent = function (t) {
		var e = "on" + t.type;
		this[e] && this[e](t);
	}, d.getSize = function () {
		this.size = e(this.element);
	}, d.css = function (t) {
		var e = this.element.style;
		for (var i in t) {
			var n = u[i] || i;
			e[n] = t[i];
		}
	}, d.getPosition = function () {
		var t = getComputedStyle(this.element),
		e = this.layout._getOption("originLeft"),
		i = this.layout._getOption("originTop"),
		n = t[e ? "left" : "right"],
		o = t[i ? "top" : "bottom"],
		r = parseFloat(n),
		s = parseFloat(o),
		a = this.layout.size;-1 != n.indexOf("%") && (r = r / 100 * a.width), -1 != o.indexOf("%") && (s = s / 100 * a.height), r = isNaN(r) ? 0 : r, s = isNaN(s) ? 0 : s, r -= e ? a.paddingLeft : a.paddingRight, s -= i ? a.paddingTop : a.paddingBottom, this.position.x = r, this.position.y = s;
	}, d.layoutPosition = function () {
		var t = this.layout.size,
		e = {},
		i = this.layout._getOption("originLeft"),
		n = this.layout._getOption("originTop"),
		o = i ? "paddingLeft" : "paddingRight",
		r = i ? "left" : "right",
		s = i ? "right" : "left",
		a = this.position.x + t[o];
		e[r] = this.getXValue(a), e[s] = "";
		var h = n ? "paddingTop" : "paddingBottom",
		u = n ? "top" : "bottom",
		d = n ? "bottom" : "top",
		l = this.position.y + t[h];
		e[u] = this.getYValue(l), e[d] = "", this.css(e), this.emitEvent("layout", [this]);
	}, d.getXValue = function (t) {
		var e = this.layout._getOption("horizontal");
		return this.layout.options.percentPosition && !e ? t / this.layout.size.width * 100 + "%" : t + "px";
	}, d.getYValue = function (t) {
		var e = this.layout._getOption("horizontal");
		return this.layout.options.percentPosition && e ? t / this.layout.size.height * 100 + "%" : t + "px";
	}, d._transitionTo = function (t, e) {
		this.getPosition();
		var i = this.position.x,
		n = this.position.y,
		o = t == this.position.x && e == this.position.y;
		if (this.setPosition(t, e), o && !this.isTransitioning) return void this.layoutPosition();
		var r = t - i,
		s = e - n,
		a = {};
		a.transform = this.getTranslate(r, s), this.transition({
			to: a,
			onTransitionEnd: {
				transform: this.layoutPosition },

			isCleaning: !0 });

	}, d.getTranslate = function (t, e) {
		var i = this.layout._getOption("originLeft"),
		n = this.layout._getOption("originTop");
		return t = i ? t : -t, e = n ? e : -e, "translate3d(" + t + "px, " + e + "px, 0)";
	}, d.goTo = function (t, e) {
		this.setPosition(t, e), this.layoutPosition();
	}, d.moveTo = d._transitionTo, d.setPosition = function (t, e) {
		this.position.x = parseFloat(t), this.position.y = parseFloat(e);
	}, d._nonTransition = function (t) {
		this.css(t.to), t.isCleaning && this._removeStyles(t.to);
		for (var e in t.onTransitionEnd) {t.onTransitionEnd[e].call(this);}
	}, d.transition = function (t) {
		if (!parseFloat(this.layout.options.transitionDuration)) return void this._nonTransition(t);
		var e = this._transn;
		for (var i in t.onTransitionEnd) {e.onEnd[i] = t.onTransitionEnd[i];}
		for (i in t.to) {e.ingProperties[i] = !0, t.isCleaning && (e.clean[i] = !0);}
		if (t.from) {
			this.css(t.from);
			var n = this.element.offsetHeight;
			n = null;
		}
		this.enableTransition(t.to), this.css(t.to), this.isTransitioning = !0;
	};
	var l = "opacity," + o(a);
	d.enableTransition = function () {
		if (!this.isTransitioning) {
			var t = this.layout.options.transitionDuration;
			t = "number" == typeof t ? t + "ms" : t, this.css({
				transitionProperty: l,
				transitionDuration: t,
				transitionDelay: this.staggerDelay || 0 }),
			this.element.addEventListener(h, this, !1);
		}
	}, d.onwebkitTransitionEnd = function (t) {
		this.ontransitionend(t);
	}, d.onotransitionend = function (t) {
		this.ontransitionend(t);
	};
	var c = {
		"-webkit-transform": "transform" };

	d.ontransitionend = function (t) {
		if (t.target === this.element) {
			var e = this._transn,
			n = c[t.propertyName] || t.propertyName;
			if (delete e.ingProperties[n], i(e.ingProperties) && this.disableTransition(), n in e.clean && (this.element.style[t.propertyName] = "", delete e.clean[n]), n in e.onEnd) {
				var o = e.onEnd[n];
				o.call(this), delete e.onEnd[n];
			}
			this.emitEvent("transitionEnd", [this]);
		}
	}, d.disableTransition = function () {
		this.removeTransitionStyles(), this.element.removeEventListener(h, this, !1), this.isTransitioning = !1;
	}, d._removeStyles = function (t) {
		var e = {};
		for (var i in t) {e[i] = "";}
		this.css(e);
	};
	var f = {
		transitionProperty: "",
		transitionDuration: "",
		transitionDelay: "" };

	return d.removeTransitionStyles = function () {
		this.css(f);
	}, d.stagger = function (t) {
		t = isNaN(t) ? 0 : t, this.staggerDelay = t + "ms";
	}, d.removeElem = function () {
		this.element.parentNode.removeChild(this.element), this.css({
			display: "" }),
		this.emitEvent("remove", [this]);
	}, d.remove = function () {
		return s && parseFloat(this.layout.options.transitionDuration) ? (this.once("transitionEnd", function () {
			this.removeElem();
		}), void this.hide()) : void this.removeElem();
	}, d.reveal = function () {
		delete this.isHidden, this.css({
			display: "" });

		var t = this.layout.options,
		e = {},
		i = this.getHideRevealTransitionEndProperty("visibleStyle");
		e[i] = this.onRevealTransitionEnd, this.transition({
			from: t.hiddenStyle,
			to: t.visibleStyle,
			isCleaning: !0,
			onTransitionEnd: e });

	}, d.onRevealTransitionEnd = function () {
		this.isHidden || this.emitEvent("reveal");
	}, d.getHideRevealTransitionEndProperty = function (t) {
		var e = this.layout.options[t];
		if (e.opacity) return "opacity";
		for (var i in e) {return i;}
	}, d.hide = function () {
		this.isHidden = !0, this.css({
			display: "" });

		var t = this.layout.options,
		e = {},
		i = this.getHideRevealTransitionEndProperty("hiddenStyle");
		e[i] = this.onHideTransitionEnd, this.transition({
			from: t.visibleStyle,
			to: t.hiddenStyle,
			isCleaning: !0,
			onTransitionEnd: e });

	}, d.onHideTransitionEnd = function () {
		this.isHidden && (this.css({
			display: "none" }),
		this.emitEvent("hide"));
	}, d.destroy = function () {
		this.css({
			position: "",
			left: "",
			right: "",
			top: "",
			bottom: "",
			transition: "",
			transform: "" });

	}, n;
}),
function (t, e) {
	"use strict";
	"function" == typeof define && define.amd ? define("outlayer/outlayer", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./item"], function (i, n, o, r) {
		return e(t, i, n, o, r);
	}) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./item")) : t.Outlayer = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, t.Outlayer.Item);
}(window, function (t, e, i, n, o) {
	"use strict";

	function r(t, e) {
		var i = n.getQueryElement(t);
		if (!i) return void (h && h.error("Bad element for " + this.constructor.namespace + ": " + (i || t)));
		this.element = i, u && (this.$element = u(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e);
		var o = ++l;
		this.element.outlayerGUID = o, c[o] = this, this._create();
		var r = this._getOption("initLayout");
		r && this.layout();
	}

	function s(t) {
		function e() {
			t.apply(this, arguments);
		}
		return e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e;
	}

	function a(t) {
		if ("number" == typeof t) return t;
		var e = t.match(/(^\d*\.?\d*)(\w*)/),
		i = e && e[1],
		n = e && e[2];
		if (!i.length) return 0;
		i = parseFloat(i);
		var o = m[n] || 1;
		return i * o;
	}
	var h = t.console,
	u = t.jQuery,
	d = function d() {},
	l = 0,
	c = {};
	r.namespace = "outlayer", r.Item = o, r.defaults = {
		containerStyle: {
			position: "relative" },

		initLayout: !0,
		originLeft: !0,
		originTop: !0,
		resize: !0,
		resizeContainer: !0,
		transitionDuration: "0.4s",
		hiddenStyle: {
			opacity: 0,
			transform: "scale(0.001)" },

		visibleStyle: {
			opacity: 1,
			transform: "scale(1)" } };


	var f = r.prototype;
	n.extend(f, e.prototype), f.option = function (t) {
		n.extend(this.options, t);
	}, f._getOption = function (t) {
		var e = this.constructor.compatOptions[t];
		return e && void 0 !== this.options[e] ? this.options[e] : this.options[t];
	}, r.compatOptions = {
		initLayout: "isInitLayout",
		horizontal: "isHorizontal",
		layoutInstant: "isLayoutInstant",
		originLeft: "isOriginLeft",
		originTop: "isOriginTop",
		resize: "isResizeBound",
		resizeContainer: "isResizingContainer" },
	f._create = function () {
		this.reloadItems(), this.stamps = [], this.stamp(this.options.stamp), n.extend(this.element.style, this.options.containerStyle);
		var t = this._getOption("resize");
		t && this.bindResize();
	}, f.reloadItems = function () {
		this.items = this._itemize(this.element.children);
	}, f._itemize = function (t) {
		for (var e = this._filterFindItemElements(t), i = this.constructor.Item, n = [], o = 0; o < e.length; o++) {
			var r = e[o],
			s = new i(r, this);
			n.push(s);
		}
		return n;
	}, f._filterFindItemElements = function (t) {
		return n.filterFindElements(t, this.options.itemSelector);
	}, f.getItemElements = function () {
		return this.items.map(function (t) {
			return t.element;
		});
	}, f.layout = function () {
		this._resetLayout(), this._manageStamps();
		var t = this._getOption("layoutInstant"),
		e = void 0 !== t ? t : !this._isLayoutInited;
		this.layoutItems(this.items, e), this._isLayoutInited = !0;
	}, f._init = f.layout, f._resetLayout = function () {
		this.getSize();
	}, f.getSize = function () {
		this.size = i(this.element);
	}, f._getMeasurement = function (t, e) {
		var n,o = this.options[t];
		o ? ("string" == typeof o ? n = this.element.querySelector(o) : o instanceof HTMLElement && (n = o), this[t] = n ? i(n)[e] : o) : this[t] = 0;
	}, f.layoutItems = function (t, e) {
		t = this._getItemsForLayout(t), this._layoutItems(t, e), this._postLayout();
	}, f._getItemsForLayout = function (t) {
		return t.filter(function (t) {
			return !t.isIgnored;
		});
	}, f._layoutItems = function (t, e) {
		if (this._emitCompleteOnItems("layout", t), t && t.length) {
			var i = [];
			t.forEach(function (t) {
				var n = this._getItemLayoutPosition(t);
				n.item = t, n.isInstant = e || t.isLayoutInstant, i.push(n);
			}, this), this._processLayoutQueue(i);
		}
	}, f._getItemLayoutPosition = function () {
		return {
			x: 0,
			y: 0 };

	}, f._processLayoutQueue = function (t) {
		this.updateStagger(), t.forEach(function (t, e) {
			this._positionItem(t.item, t.x, t.y, t.isInstant, e);
		}, this);
	}, f.updateStagger = function () {
		var t = this.options.stagger;
		return null === t || void 0 === t ? void (this.stagger = 0) : (this.stagger = a(t), this.stagger);
	}, f._positionItem = function (t, e, i, n, o) {
		n ? t.goTo(e, i) : (t.stagger(o * this.stagger), t.moveTo(e, i));
	}, f._postLayout = function () {
		this.resizeContainer();
	}, f.resizeContainer = function () {
		var t = this._getOption("resizeContainer");
		if (t) {
			var e = this._getContainerSize();
			e && (this._setContainerMeasure(e.width, !0), this._setContainerMeasure(e.height, !1));
		}
	}, f._getContainerSize = d, f._setContainerMeasure = function (t, e) {
		if (void 0 !== t) {
			var i = this.size;
			i.isBorderBox && (t += e ? i.paddingLeft + i.paddingRight + i.borderLeftWidth + i.borderRightWidth : i.paddingBottom + i.paddingTop + i.borderTopWidth + i.borderBottomWidth), t = Math.max(t, 0), this.element.style[e ? "width" : "height"] = t + "px";
		}
	}, f._emitCompleteOnItems = function (t, e) {
		function i() {
			o.dispatchEvent(t + "Complete", null, [e]);
		}

		function n() {
			s++, s == r && i();
		}
		var o = this,
		r = e.length;
		if (!e || !r) return void i();
		var s = 0;
		e.forEach(function (e) {
			e.once(t, n);
		});
	}, f.dispatchEvent = function (t, e, i) {
		var n = e ? [e].concat(i) : i;
		if (this.emitEvent(t, n), u)
		if (this.$element = this.$element || u(this.element), e) {
			var o = u.Event(e);
			o.type = t, this.$element.trigger(o, i);
		} else this.$element.trigger(t, i);
	}, f.ignore = function (t) {
		var e = this.getItem(t);
		e && (e.isIgnored = !0);
	}, f.unignore = function (t) {
		var e = this.getItem(t);
		e && delete e.isIgnored;
	}, f.stamp = function (t) {
		t = this._find(t), t && (this.stamps = this.stamps.concat(t), t.forEach(this.ignore, this));
	}, f.unstamp = function (t) {
		t = this._find(t), t && t.forEach(function (t) {
			n.removeFrom(this.stamps, t), this.unignore(t);
		}, this);
	}, f._find = function (t) {
		return t ? ("string" == typeof t && (t = this.element.querySelectorAll(t)), t = n.makeArray(t)) : void 0;
	}, f._manageStamps = function () {
		this.stamps && this.stamps.length && (this._getBoundingRect(), this.stamps.forEach(this._manageStamp, this));
	}, f._getBoundingRect = function () {
		var t = this.element.getBoundingClientRect(),
		e = this.size;
		this._boundingRect = {
			left: t.left + e.paddingLeft + e.borderLeftWidth,
			top: t.top + e.paddingTop + e.borderTopWidth,
			right: t.right - (e.paddingRight + e.borderRightWidth),
			bottom: t.bottom - (e.paddingBottom + e.borderBottomWidth) };

	}, f._manageStamp = d, f._getElementOffset = function (t) {
		var e = t.getBoundingClientRect(),
		n = this._boundingRect,
		o = i(t),
		r = {
			left: e.left - n.left - o.marginLeft,
			top: e.top - n.top - o.marginTop,
			right: n.right - e.right - o.marginRight,
			bottom: n.bottom - e.bottom - o.marginBottom };

		return r;
	}, f.handleEvent = n.handleEvent, f.bindResize = function () {
		t.addEventListener("resize", this), this.isResizeBound = !0;
	}, f.unbindResize = function () {
		t.removeEventListener("resize", this), this.isResizeBound = !1;
	}, f.onresize = function () {
		this.resize();
	}, n.debounceMethod(r, "onresize", 100), f.resize = function () {
		this.isResizeBound && this.needsResizeLayout() && this.layout();
	}, f.needsResizeLayout = function () {
		var t = i(this.element),
		e = this.size && t;
		return e && t.innerWidth !== this.size.innerWidth;
	}, f.addItems = function (t) {
		var e = this._itemize(t);
		return e.length && (this.items = this.items.concat(e)), e;
	}, f.appended = function (t) {
		var e = this.addItems(t);
		e.length && (this.layoutItems(e, !0), this.reveal(e));
	}, f.prepended = function (t) {
		var e = this._itemize(t);
		if (e.length) {
			var i = this.items.slice(0);
			this.items = e.concat(i), this._resetLayout(), this._manageStamps(), this.layoutItems(e, !0), this.reveal(e), this.layoutItems(i);
		}
	}, f.reveal = function (t) {
		if (this._emitCompleteOnItems("reveal", t), t && t.length) {
			var e = this.updateStagger();
			t.forEach(function (t, i) {
				t.stagger(i * e), t.reveal();
			});
		}
	}, f.hide = function (t) {
		if (this._emitCompleteOnItems("hide", t), t && t.length) {
			var e = this.updateStagger();
			t.forEach(function (t, i) {
				t.stagger(i * e), t.hide();
			});
		}
	}, f.revealItemElements = function (t) {
		var e = this.getItems(t);
		this.reveal(e);
	}, f.hideItemElements = function (t) {
		var e = this.getItems(t);
		this.hide(e);
	}, f.getItem = function (t) {
		for (var e = 0; e < this.items.length; e++) {
			var i = this.items[e];
			if (i.element == t) return i;
		}
	}, f.getItems = function (t) {
		t = n.makeArray(t);
		var e = [];
		return t.forEach(function (t) {
			var i = this.getItem(t);
			i && e.push(i);
		}, this), e;
	}, f.remove = function (t) {
		var e = this.getItems(t);
		this._emitCompleteOnItems("remove", e), e && e.length && e.forEach(function (t) {
			t.remove(), n.removeFrom(this.items, t);
		}, this);
	}, f.destroy = function () {
		var t = this.element.style;
		t.height = "", t.position = "", t.width = "", this.items.forEach(function (t) {
			t.destroy();
		}), this.unbindResize();
		var e = this.element.outlayerGUID;
		delete c[e], delete this.element.outlayerGUID, u && u.removeData(this.element, this.constructor.namespace);
	}, r.data = function (t) {
		t = n.getQueryElement(t);
		var e = t && t.outlayerGUID;
		return e && c[e];
	}, r.create = function (t, e) {
		var i = s(r);
		return i.defaults = n.extend({}, r.defaults), n.extend(i.defaults, e), i.compatOptions = n.extend({}, r.compatOptions), i.namespace = t, i.data = r.data, i.Item = s(o), n.htmlInit(i, t), u && u.bridget && u.bridget(t, i), i;
	};
	var m = {
		ms: 1,
		s: 1e3 };

	return r.Item = o, r;
}),
function (t, e) {
	"function" == typeof define && define.amd ? define(["outlayer/outlayer", "get-size/get-size"], e) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = e(require("outlayer"), require("get-size")) : t.Masonry = e(t.Outlayer, t.getSize);
}(window, function (t, e) {
	var i = t.create("masonry");
	i.compatOptions.fitWidth = "isFitWidth";
	var n = i.prototype;
	return n._resetLayout = function () {
		this.getSize(), this._getMeasurement("columnWidth", "outerWidth"), this._getMeasurement("gutter", "outerWidth"), this.measureColumns(), this.colYs = [];
		for (var t = 0; t < this.cols; t++) {this.colYs.push(0);}
		this.maxY = 0, this.horizontalColIndex = 0;
	}, n.measureColumns = function () {
		if (this.getContainerWidth(), !this.columnWidth) {
			var t = this.items[0],
			i = t && t.element;
			this.columnWidth = i && e(i).outerWidth || this.containerWidth;
		}
		var n = this.columnWidth += this.gutter,
		o = this.containerWidth + this.gutter,
		r = o / n,
		s = n - o % n,
		a = s && 1 > s ? "round" : "floor";
		r = Math[a](r), this.cols = Math.max(r, 1);
	}, n.getContainerWidth = function () {
		var t = this._getOption("fitWidth"),
		i = t ? this.element.parentNode : this.element,
		n = e(i);
		this.containerWidth = n && n.innerWidth;
	}, n._getItemLayoutPosition = function (t) {
		t.getSize();
		var e = t.size.outerWidth % this.columnWidth,
		i = e && 1 > e ? "round" : "ceil",
		n = Math[i](t.size.outerWidth / this.columnWidth);
		n = Math.min(n, this.cols);
		for (var o = this.options.horizontalOrder ? "_getHorizontalColPosition" : "_getTopColPosition", r = this[o](n, t), s = {
			x: this.columnWidth * r.col,
			y: r.y },
		a = r.y + t.size.outerHeight, h = n + r.col, u = r.col; h > u; u++) {this.colYs[u] = a;}
		return s;
	}, n._getTopColPosition = function (t) {
		var e = this._getTopColGroup(t),
		i = Math.min.apply(Math, e);
		return {
			col: e.indexOf(i),
			y: i };

	}, n._getTopColGroup = function (t) {
		if (2 > t) return this.colYs;
		for (var e = [], i = this.cols + 1 - t, n = 0; i > n; n++) {e[n] = this._getColGroupY(n, t);}
		return e;
	}, n._getColGroupY = function (t, e) {
		if (2 > e) return this.colYs[t];
		var i = this.colYs.slice(t, t + e);
		return Math.max.apply(Math, i);
	}, n._getHorizontalColPosition = function (t, e) {
		var i = this.horizontalColIndex % this.cols,
		n = t > 1 && i + t > this.cols;
		i = n ? 0 : i;
		var o = e.size.outerWidth && e.size.outerHeight;
		return this.horizontalColIndex = o ? i + t : this.horizontalColIndex, {
			col: i,
			y: this._getColGroupY(i, t) };

	}, n._manageStamp = function (t) {
		var i = e(t),
		n = this._getElementOffset(t),
		o = this._getOption("originLeft"),
		r = o ? n.left : n.right,
		s = r + i.outerWidth,
		a = Math.floor(r / this.columnWidth);
		a = Math.max(0, a);
		var h = Math.floor(s / this.columnWidth);
		h -= s % this.columnWidth ? 0 : 1, h = Math.min(this.cols - 1, h);
		for (var u = this._getOption("originTop"), d = (u ? n.top : n.bottom) + i.outerHeight, l = a; h >= l; l++) {this.colYs[l] = Math.max(d, this.colYs[l]);}
	}, n._getContainerSize = function () {
		this.maxY = Math.max.apply(Math, this.colYs);
		var t = {
			height: this.maxY };

		return this._getOption("fitWidth") && (t.width = this._getContainerFitWidth()), t;
	}, n._getContainerFitWidth = function () {
		for (var t = 0, e = this.cols; --e && 0 === this.colYs[e];) {t++;}
		return (this.cols - t) * this.columnWidth - this.gutter;
	}, n.needsResizeLayout = function () {
		var t = this.containerWidth;
		return this.getContainerWidth(), t != this.containerWidth;
	}, i;
});
"use strict";var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}; /*! modernizr 3.6.0 (Custom Build) | MIT *
                                                                                                                                                                                                                                                                                        * https://modernizr.com/download/?-adownload-animation-appearance-bgsizecover-boxsizing-canvas-checked-cookies-cryptography-cssanimations-csscalc-csscolumns-cssgradients-cssgrid_cssgridlegacy-cssinvalid-csspointerevents-cssremunit-csstransforms-csstransforms3d-csstransitions-cssvalid-cssvhunit-cssvmaxunit-cssvminunit-cssvwunit-datalistelem-datauri-details-filereader-filesystem-flexbox-flexboxlegacy-flexboxtweener-flexwrap-formvalidation-framed-fullscreen-generatedcontent-geolocation-getusermedia-hidden-history-indexeddb-inlinesvg-input-inputtypes-localstorage-matchmedia-microdata-notification-nthchild-objectfit-outputelem-pagevisibility-postmessage-progressbar_meter-search-serviceworker-sessionstorage-srcset-supports-svg-target-time-touchevents-video-webgl-websockets-websqldatabase-webworkers-addtest-mq-setclasses !*/
!function (e, t, n) {function i(e, t) {return (typeof e === "undefined" ? "undefined" : _typeof(e)) === t;}function r() {var e, t, n, r, o, a, s;for (var d in A) {if (A.hasOwnProperty(d)) {if (e = [], t = A[d], t.name && (e.push(t.name.toLowerCase()), t.options && t.options.aliases && t.options.aliases.length)) for (n = 0; n < t.options.aliases.length; n++) {e.push(t.options.aliases[n].toLowerCase());}for (r = i(t.fn, "function") ? t.fn() : t.fn, o = 0; o < e.length; o++) {a = e[o], s = a.split("."), 1 === s.length ? Modernizr[s[0]] = r : (!Modernizr[s[0]] || Modernizr[s[0]] instanceof Boolean || (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])), Modernizr[s[0]][s[1]] = r), w.push((r ? "" : "no-") + s.join("-"));}}}}function o(e) {var t = I.className,n = Modernizr._config.classPrefix || "";if (P && (t = t.baseVal), Modernizr._config.enableJSClass) {var i = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");t = t.replace(i, "$1" + n + "js$2");}Modernizr._config.enableClasses && (t += " " + n + e.join(" " + n), P ? I.className.baseVal = t : I.className = t);}function a(e, t) {if ("object" == (typeof e === "undefined" ? "undefined" : _typeof(e))) for (var n in e) {E(e, n) && a(n, e[n]);} else {e = e.toLowerCase();var i = e.split("."),r = Modernizr[i[0]];if (2 == i.length && (r = r[i[1]]), "undefined" != typeof r) return Modernizr;t = "function" == typeof t ? t() : t, 1 == i.length ? Modernizr[i[0]] = t : (!Modernizr[i[0]] || Modernizr[i[0]] instanceof Boolean || (Modernizr[i[0]] = new Boolean(Modernizr[i[0]])), Modernizr[i[0]][i[1]] = t), o([(t && 0 != t ? "" : "no-") + i.join("-")]), Modernizr._trigger(e, t);}return Modernizr;}function s() {return "function" != typeof t.createElement ? t.createElement(arguments[0]) : P ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0]) : t.createElement.apply(t, arguments);}function d(t, n, i) {var r;if ("getComputedStyle" in e) {r = getComputedStyle.call(e, t, n);var o = e.console;if (null !== r) i && (r = r.getPropertyValue(i));else if (o) {var a = o.error ? "error" : "log";o[a].call(o, "getComputedStyle returning null, its possible modernizr test results are inaccurate");}} else r = !n && t.currentStyle && t.currentStyle[i];return r;}function l(e, t) {return e - 1 === t || e === t || e + 1 === t;}function c() {var e = t.body;return e || (e = s(P ? "svg" : "body"), e.fake = !0), e;}function u(e, n, i, r) {var o,a,d,l,u = "modernizr",f = s("div"),p = c();if (parseInt(i, 10)) for (; i--;) {d = s("div"), d.id = r ? r[i] : u + (i + 1), f.appendChild(d);}return o = s("style"), o.type = "text/css", o.id = "s" + u, (p.fake ? p : f).appendChild(o), p.appendChild(f), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(t.createTextNode(e)), f.id = u, p.fake && (p.style.background = "", p.style.overflow = "hidden", l = I.style.overflow, I.style.overflow = "hidden", I.appendChild(p)), a = n(f, e), p.fake ? (p.parentNode.removeChild(p), I.style.overflow = l, I.offsetHeight) : f.parentNode.removeChild(f), !!a;}function f(e) {return e.replace(/([a-z])-([a-z])/g, function (e, t, n) {return t + n.toUpperCase();}).replace(/^-/, "");}function p(e, t) {return !!~("" + e).indexOf(t);}function m(e, t) {return function () {return e.apply(t, arguments);};}function h(e, t, n) {var r;for (var o in e) {if (e[o] in t) return n === !1 ? e[o] : (r = t[e[o]], i(r, "function") ? m(r, n || t) : r);}return !1;}function v(e) {return e.replace(/([A-Z])/g, function (e, t) {return "-" + t.toLowerCase();}).replace(/^ms-/, "-ms-");}function g(t, i) {var r = t.length;if ("CSS" in e && "supports" in e.CSS) {for (; r--;) {if (e.CSS.supports(v(t[r]), i)) return !0;}return !1;}if ("CSSSupportsRule" in e) {for (var o = []; r--;) {o.push("(" + v(t[r]) + ":" + i + ")");}return o = o.join(" or "), u("@supports (" + o + ") { #modernizr { position: absolute; } }", function (e) {return "absolute" == d(e, null, "position");});}return n;}function y(e, t, r, o) {function a() {l && (delete F.style, delete F.modElem);}if (o = i(o, "undefined") ? !1 : o, !i(r, "undefined")) {var d = g(e, r);if (!i(d, "undefined")) return d;}for (var l, c, u, m, h, v = ["modernizr", "tspan", "samp"]; !F.style && v.length;) {l = !0, F.modElem = s(v.shift()), F.style = F.modElem.style;}for (u = e.length, c = 0; u > c; c++) {if (m = e[c], h = F.style[m], p(m, "-") && (m = f(m)), F.style[m] !== n) {if (o || i(r, "undefined")) return a(), "pfx" == t ? m : !0;try {F.style[m] = r;} catch (y) {}if (F.style[m] != h) return a(), "pfx" == t ? m : !0;}}return a(), !1;}function T(e, t, n, r, o) {var a = e.charAt(0).toUpperCase() + e.slice(1),s = (e + " " + H.join(a + " ") + a).split(" ");return i(t, "string") || i(t, "undefined") ? y(s, t, r, o) : (s = (e + " " + V.join(a + " ") + a).split(" "), h(s, t, n));}function b(e, t) {var n = e.deleteDatabase(t);n.onsuccess = function () {a("indexeddb.deletedatabase", !0);}, n.onerror = function () {a("indexeddb.deletedatabase", !1);};}function x(e, t, i) {return T(e, n, n, t, i);}var w = [],A = [],S = { _version: "3.6.0", _config: { classPrefix: "", enableClasses: !0, enableJSClass: !0, usePrefixes: !0 }, _q: [], on: function on(e, t) {var n = this;setTimeout(function () {t(n[e]);}, 0);}, addTest: function addTest(e, t, n) {A.push({ name: e, fn: t, options: n });}, addAsyncTest: function addAsyncTest(e) {A.push({ name: null, fn: e });} },Modernizr = function Modernizr() {};Modernizr.prototype = S, Modernizr = new Modernizr(), Modernizr.addTest("cookies", function () {try {t.cookie = "cookietest=1";var e = -1 != t.cookie.indexOf("cookietest=");return t.cookie = "cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT", e;} catch (n) {return !1;}}), Modernizr.addTest("geolocation", "geolocation" in navigator), Modernizr.addTest("history", function () {var t = navigator.userAgent;return -1 === t.indexOf("Android 2.") && -1 === t.indexOf("Android 4.0") || -1 === t.indexOf("Mobile Safari") || -1 !== t.indexOf("Chrome") || -1 !== t.indexOf("Windows Phone") || "file:" === location.protocol ? e.history && "pushState" in e.history : !1;}), Modernizr.addTest("notification", function () {if (!e.Notification || !e.Notification.requestPermission) return !1;if ("granted" === e.Notification.permission) return !0;try {new e.Notification("");} catch (t) {if ("TypeError" === t.name) return !1;}return !0;}), Modernizr.addTest("postmessage", "postMessage" in e), Modernizr.addTest("serviceworker", "serviceWorker" in navigator), Modernizr.addTest("svg", !!t.createElementNS && !!t.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect);var C = !1;try {C = "WebSocket" in e && 2 === e.WebSocket.CLOSING;} catch (k) {}Modernizr.addTest("websockets", C);var z = "CSS" in e && "supports" in e.CSS,_ = "supportsCSS" in e;Modernizr.addTest("supports", z || _), Modernizr.addTest("target", function () {var t = e.document;if (!("querySelectorAll" in t)) return !1;try {return t.querySelectorAll(":target"), !0;} catch (n) {return !1;}}), Modernizr.addTest("microdata", "getItems" in t), Modernizr.addTest("filereader", !!(e.File && e.FileList && e.FileReader)), Modernizr.addTest("localstorage", function () {var e = "modernizr";try {return localStorage.setItem(e, e), localStorage.removeItem(e), !0;} catch (t) {return !1;}}), Modernizr.addTest("sessionstorage", function () {var e = "modernizr";try {return sessionStorage.setItem(e, e), sessionStorage.removeItem(e), !0;} catch (t) {return !1;}}), Modernizr.addTest("websqldatabase", "openDatabase" in e), Modernizr.addTest("getUserMedia", "mediaDevices" in navigator && "getUserMedia" in navigator.mediaDevices), Modernizr.addTest("framed", e.location != top.location), Modernizr.addTest("webworkers", "Worker" in e);var E,I = t.documentElement,P = "svg" === I.nodeName.toLowerCase();!function () {var e = {}.hasOwnProperty;E = i(e, "undefined") || i(e.call, "undefined") ? function (e, t) {return t in e && i(e.constructor.prototype[t], "undefined");} : function (t, n) {return e.call(t, n);};}(), S._l = {}, S.on = function (e, t) {this._l[e] || (this._l[e] = []), this._l[e].push(t), Modernizr.hasOwnProperty(e) && setTimeout(function () {Modernizr._trigger(e, Modernizr[e]);}, 0);}, S._trigger = function (e, t) {if (this._l[e]) {var n = this._l[e];setTimeout(function () {var e, i;for (e = 0; e < n.length; e++) {(i = n[e])(t);}}, 0), delete this._l[e];}}, Modernizr._q.push(function () {S.addTest = a;}), Modernizr.addAsyncTest(function () {function e() {var e = new Image();e.onerror = function () {a("datauri", !0), Modernizr.datauri = new Boolean(!0), Modernizr.datauri.over32kb = !1;}, e.onload = function () {a("datauri", !0), Modernizr.datauri = new Boolean(!0), Modernizr.datauri.over32kb = 1 == e.width && 1 == e.height;};for (var t = "R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw=="; t.length < 33e3;) {t = "\r\n" + t;}e.src = "data:image/gif;base64," + t;}-1 !== navigator.userAgent.indexOf("MSIE 7.") && setTimeout(function () {a("datauri", !1);}, 10);var t = new Image();t.onerror = function () {a("datauri", !1);}, t.onload = function () {1 == t.width && 1 == t.height ? e() : a("datauri", !1);}, t.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";}), Modernizr.addTest("canvas", function () {var e = s("canvas");return !(!e.getContext || !e.getContext("2d"));}), Modernizr.addTest("video", function () {var e = s("video"),t = !1;try {t = !!e.canPlayType, t && (t = new Boolean(t), t.ogg = e.canPlayType('video/ogg; codecs="theora"').replace(/^no$/, ""), t.h264 = e.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/, ""), t.webm = e.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/, ""), t.vp9 = e.canPlayType('video/webm; codecs="vp9"').replace(/^no$/, ""), t.hls = e.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/, ""));} catch (n) {}return t;}), Modernizr.addTest("webanimations", "animate" in s("div")), Modernizr.addTest("webgl", function () {var t = s("canvas"),n = "probablySupportsContext" in t ? "probablySupportsContext" : "supportsContext";return n in t ? t[n]("webgl") || t[n]("experimental-webgl") : "WebGLRenderingContext" in e;}), Modernizr.addTest("adownload", !e.externalHost && "download" in s("a")), Modernizr.addTest("csspointerevents", function () {var e = s("a").style;return e.cssText = "pointer-events:auto", "auto" === e.pointerEvents;}), Modernizr.addTest("cssremunit", function () {var e = s("a").style;try {e.fontSize = "3rem";} catch (t) {}return (/rem/.test(e.fontSize));}), Modernizr.addTest("hidden", "hidden" in s("a")), Modernizr.addTest("outputelem", "value" in s("output")), Modernizr.addTest("progressbar", s("progress").max !== n), Modernizr.addTest("meter", s("meter").max !== n), Modernizr.addTest("time", "valueAsDate" in s("time")), Modernizr.addTest("srcset", "srcset" in s("img")), Modernizr.addTest("inlinesvg", function () {var e = s("div");return e.innerHTML = "<svg/>", "http://www.w3.org/2000/svg" == ("undefined" != typeof SVGRect && e.firstChild && e.firstChild.namespaceURI);});var N = s("input"),L = "autocomplete autofocus list placeholder max min multiple pattern required step".split(" "),M = {};Modernizr.input = function (t) {for (var n = 0, i = t.length; i > n; n++) {M[t[n]] = !!(t[n] in N);}return M.list && (M.list = !(!s("datalist") || !e.HTMLDataListElement)), M;}(L), Modernizr.addTest("datalistelem", Modernizr.input.list);var O = "search tel url email datetime date month week time datetime-local number range color".split(" "),W = {};Modernizr.inputtypes = function (e) {for (var i, r, o, a = e.length, s = "1)", d = 0; a > d; d++) {N.setAttribute("type", i = e[d]), o = "text" !== N.type && "style" in N, o && (N.value = s, N.style.cssText = "position:absolute;visibility:hidden;", /^range$/.test(i) && N.style.WebkitAppearance !== n ? (I.appendChild(N), r = t.defaultView, o = r.getComputedStyle && "textfield" !== r.getComputedStyle(N, null).WebkitAppearance && 0 !== N.offsetHeight, I.removeChild(N)) : /^(search|tel)$/.test(i) || (o = /^(url|email)$/.test(i) ? N.checkValidity && N.checkValidity() === !1 : N.value != s)), W[e[d]] = !!o;}return W;}(O);var B = function () {function e(e, t) {var r;return e ? (t && "string" != typeof t || (t = s(t || "div")), e = "on" + e, r = e in t, !r && i && (t.setAttribute || (t = s("div")), t.setAttribute(e, ""), r = "function" == typeof t[e], t[e] !== n && (t[e] = n), t.removeAttribute(e)), r) : !1;}var i = !("onblur" in t.documentElement);return e;}();S.hasEvent = B, Modernizr.addTest("inputsearchevent", B("search"));var R = S._config.usePrefixes ? " -webkit- -moz- -o- -ms- ".split(" ") : ["", ""];S._prefixes = R, Modernizr.addTest("csscalc", function () {var e = "width:",t = "calc(10px);",n = s("a");return n.style.cssText = e + R.join(t + e), !!n.style.length;}), Modernizr.addTest("cssgradients", function () {for (var e, t = "background-image:", n = "gradient(linear,left top,right bottom,from(#9f9),to(white));", i = "", r = 0, o = R.length - 1; o > r; r++) {e = 0 === r ? "to " : "", i += t + R[r] + "linear-gradient(" + e + "left top, #9f9, white);";}Modernizr._config.usePrefixes && (i += t + "-webkit-" + n);var a = s("a"),d = a.style;return d.cssText = i, ("" + d.backgroundImage).indexOf("gradient") > -1;});var q = function () {var t = e.matchMedia || e.msMatchMedia;return t ? function (e) {var n = t(e);return n && n.matches || !1;} : function (t) {var n = !1;return u("@media " + t + " { #modernizr { position: absolute; } }", function (t) {n = "absolute" == (e.getComputedStyle ? e.getComputedStyle(t, null) : t.currentStyle).position;}), n;};}();S.mq = q;var j = S.testStyles = u;Modernizr.addTest("touchevents", function () {var n;if ("ontouchstart" in e || e.DocumentTouch && t instanceof DocumentTouch) n = !0;else {var i = ["@media (", R.join("touch-enabled),("), "heartz", ")", "{#modernizr{top:9px;position:absolute}}"].join("");j(i, function (e) {n = 9 === e.offsetTop;});}return n;}), Modernizr.addTest("checked", function () {return j("#modernizr {position:absolute} #modernizr input {margin-left:10px} #modernizr :checked {margin-left:20px;display:block}", function (e) {var t = s("input");return t.setAttribute("type", "checkbox"), t.setAttribute("checked", "checked"), e.appendChild(t), 20 === t.offsetLeft;});}), j('#modernizr{font:0/0 a}#modernizr:after{content:":)";visibility:hidden;font:7px/1 a}', function (e) {Modernizr.addTest("generatedcontent", e.offsetHeight >= 6);}), Modernizr.addTest("cssinvalid", function () {return j("#modernizr input{height:0;border:0;padding:0;margin:0;width:10px} #modernizr input:invalid{width:50px}", function (e) {var t = s("input");return t.required = !0, e.appendChild(t), t.clientWidth > 10;});}), j("#modernizr div {width:1px} #modernizr div:nth-child(2n) {width:2px;}", function (e) {for (var t = e.getElementsByTagName("div"), n = !0, i = 0; 5 > i; i++) {n = n && t[i].offsetWidth === i % 2 + 1;}Modernizr.addTest("nthchild", n);}, 5), Modernizr.addTest("cssvalid", function () {return j("#modernizr input{height:0;border:0;padding:0;margin:0;width:10px} #modernizr input:valid{width:50px}", function (e) {var t = s("input");return e.appendChild(t), t.clientWidth > 10;});}), j("#modernizr { height: 50vh; }", function (t) {var n = parseInt(e.innerHeight / 2, 10),i = parseInt(d(t, null, "height"), 10);Modernizr.addTest("cssvhunit", l(i, n));}), j("#modernizr1{width: 50vmax}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function (e) {var t = e.childNodes[2],n = e.childNodes[1],i = e.childNodes[0],r = parseInt((n.offsetWidth - n.clientWidth) / 2, 10),o = i.clientWidth / 100,a = i.clientHeight / 100,s = parseInt(50 * Math.max(o, a), 10),c = parseInt(d(t, null, "width"), 10);Modernizr.addTest("cssvmaxunit", l(s, c) || l(s, c - r));}, 3), j("#modernizr1{width: 50vm;width:50vmin}#modernizr2{width:50px;height:50px;overflow:scroll}#modernizr3{position:fixed;top:0;left:0;bottom:0;right:0}", function (e) {var t = e.childNodes[2],n = e.childNodes[1],i = e.childNodes[0],r = parseInt((n.offsetWidth - n.clientWidth) / 2, 10),o = i.clientWidth / 100,a = i.clientHeight / 100,s = parseInt(50 * Math.min(o, a), 10),c = parseInt(d(t, null, "width"), 10);Modernizr.addTest("cssvminunit", l(s, c) || l(s, c - r));}, 3), j("#modernizr { width: 50vw; }", function (t) {var n = parseInt(e.innerWidth / 2, 10),i = parseInt(d(t, null, "width"), 10);Modernizr.addTest("cssvwunit", l(i, n));}), Modernizr.addTest("details", function () {var e,t = s("details");return "open" in t ? (j("#modernizr details{display:block}", function (n) {n.appendChild(t), t.innerHTML = "<summary>a</summary>b", e = t.offsetHeight, t.open = !0, e = e != t.offsetHeight;}), e) : !1;}), Modernizr.addTest("formvalidation", function () {var t = s("form");if (!("checkValidity" in t && "addEventListener" in t)) return !1;if ("reportValidity" in t) return !0;var n,i = !1;return Modernizr.formvalidationapi = !0, t.addEventListener("submit", function (t) {(!e.opera || e.operamini) && t.preventDefault(), t.stopPropagation();}, !1), t.innerHTML = '<input name="modTest" required="required" /><button></button>', j("#modernizr form{position:absolute;top:-99999em}", function (e) {e.appendChild(t), n = t.getElementsByTagName("input")[0], n.addEventListener("invalid", function (e) {i = !0, e.preventDefault(), e.stopPropagation();}, !1), Modernizr.formvalidationmessage = !!n.validationMessage, t.getElementsByTagName("button")[0].click();}), i;});var D = "Moz O ms Webkit",H = S._config.usePrefixes ? D.split(" ") : [];S._cssomPrefixes = H;var U = function U(t) {var i,r = R.length,o = e.CSSRule;if ("undefined" == typeof o) return n;if (!t) return !1;if (t = t.replace(/^@/, ""), i = t.replace(/-/g, "_").toUpperCase() + "_RULE", i in o) return "@" + t;for (var a = 0; r > a; a++) {var s = R[a],d = s.toUpperCase() + "_" + i;if (d in o) return "@-" + s.toLowerCase() + "-" + t;}return !1;};S.atRule = U;var V = S._config.usePrefixes ? D.toLowerCase().split(" ") : [];S._domPrefixes = V;var $ = { elem: s("modernizr") };Modernizr._q.push(function () {delete $.elem;});var F = { style: $.elem.style };Modernizr._q.unshift(function () {delete F.style;}), S.testAllProps = T;var G = S.prefixed = function (e, t, n) {return 0 === e.indexOf("@") ? U(e) : (-1 != e.indexOf("-") && (e = f(e)), t ? T(e, t, n) : T(e, "pfx"));},Q = G("crypto", e);Modernizr.addTest("crypto", !!G("subtle", Q)), Modernizr.addTest("fullscreen", !(!G("exitFullscreen", t, !1) && !G("cancelFullScreen", t, !1))), Modernizr.addAsyncTest(function () {var t;try {t = G("indexedDB", e);} catch (n) {}if (t) {var i = "modernizr-" + Math.random(),r = t.open(i);r.onerror = function () {r.error && "InvalidStateError" === r.error.name ? a("indexeddb", !1) : (a("indexeddb", !0), b(t, i));}, r.onsuccess = function () {a("indexeddb", !0), b(t, i);};} else a("indexeddb", !1);}), Modernizr.addTest("pagevisibility", !!G("hidden", t, !1)), Modernizr.addTest("objectfit", !!G("objectFit"), { aliases: ["object-fit"] }), Modernizr.addTest("filesystem", !!G("requestFileSystem", e)), Modernizr.addTest("matchmedia", !!G("matchMedia", e)), S.testAllProps = x, Modernizr.addTest("cssanimations", x("animationName", "a", !0)), Modernizr.addTest("appearance", x("appearance")), Modernizr.addTest("bgsizecover", x("backgroundSize", "cover")), Modernizr.addTest("boxsizing", x("boxSizing", "border-box", !0) && (t.documentMode === n || t.documentMode > 7)), function () {Modernizr.addTest("csscolumns", function () {var e = !1,t = x("columnCount");try {e = !!t, e && (e = new Boolean(e));} catch (n) {}return e;});for (var e, t, n = ["Width", "Span", "Fill", "Gap", "Rule", "RuleColor", "RuleStyle", "RuleWidth", "BreakBefore", "BreakAfter", "BreakInside"], i = 0; i < n.length; i++) {e = n[i].toLowerCase(), t = x("column" + n[i]), ("breakbefore" === e || "breakafter" === e || "breakinside" == e) && (t = t || x(n[i])), Modernizr.addTest("csscolumns." + e, t);}}(), Modernizr.addTest("cssgridlegacy", x("grid-columns", "10px", !0)), Modernizr.addTest("cssgrid", x("grid-template-rows", "none", !0)), Modernizr.addTest("flexbox", x("flexBasis", "1px", !0)), Modernizr.addTest("flexboxlegacy", x("boxDirection", "reverse", !0)), Modernizr.addTest("flexboxtweener", x("flexAlign", "end", !0)), Modernizr.addTest("csstransforms", function () {return -1 === navigator.userAgent.indexOf("Android 2.") && x("transform", "scale(1)", !0);}), Modernizr.addTest("csstransforms3d", function () {return !!x("perspective", "1px", !0);}), Modernizr.addTest("csstransitions", x("transition", "all", !0)), Modernizr.addTest("flexwrap", x("flexWrap", "wrap", !0)), r(), o(w), delete S.addTest, delete S.addAsyncTest;for (var J = 0; J < Modernizr._q.length; J++) {Modernizr._q[J]();}e.Modernizr = Modernizr;}(window, document);
'use strict'; /********
               ****** NinjaSlider, multipurpose html slider, it relies heavily in Function.prototype.bind, RequesAnimationFrame and css transitions
               ****** Support: IE10+
               ****** Author: Fernando Silva
               ****** URL: http://www.github.com/fdograph
               *****/

/////////////////////////////////
///////////////////////////////// NinjaSlider Class
/////////////////////////////////
(function (window, document) {
	"strict mode";

	var support = {
		touch: 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
		pointers: window.navigator.msPointerEnabled || window.navigator.pointerEnabled,
		transitions: function (temp) {
			var props = ['transitionProperty', 'WebkitTransition'],
			i;
			for (i in props) {
				if (temp.style[props[i]] !== undefined) {
					return true;
				}
			}
			return false;
		}(document.createElement('ninja')) };


	///// auxiliars
	var addListeners = function addListeners(element, events, handler) {
		events.forEach(function (e) {
			element.addEventListener(e, handler);
		});
	};
	var removeListeners = function removeListeners(element, events, handler) {
		events.forEach(function (e) {
			element.removeEventListener(e, handler);
		});
	};
	var getCoords = function getCoords(event) {
		var x, y;

		if (support.touch) {
			if (event.touches && event.touches[0]) {
				x = event.touches[0].pageX;
				y = event.touches[0].pageY;
			} else if (event.changedTouches && event.changedTouches[0]) {
				x = event.changedTouches[0].pageX;
				y = event.changedTouches[0].pageY;
			}
		} else {
			x = event.pageX;
			y = event.pageY;
		}

		return {
			x: x,
			y: y };

	};
	var extend = function extend() {
		var i, key;
		for (i = 1; i < arguments.length; i++) {
			for (key in arguments[i]) {
				if (arguments[i].hasOwnProperty(key)) {
					arguments[0][key] = arguments[i][key];
				}
			}
		}
		return arguments[0];
	};

	window.NinjaSlider = function (container, options) {
		if (!support.transitions) {
			return false;
		}

		this.defaults = {
			auto: 2000,
			speed: 400,
			throttle: 300,
			effect: 'slide',
			handleKeys: true,
			blockScrolling: false,
			slideStart: false
			// transitionCallback : function( index, item, slider ){},
		};
		this.settings = extend(this.defaults, options || {});

		this.container = container;
		this.list = this.container.children[0];
		this.items = Array.prototype.map.call(this.list.children, function (e) {
			return e;
		});

		/// events closures
		this.setupClosures();

		this.initialized = false;
		this.resizeTimeout = null;
		this.setup();
		this.eventsHandler('engage');

		if (this.settings.auto) {
			this.autoInterval = setInterval(this.next.bind(this), this.settings.auto);
		}

		var effect = this.settings.effect;
		if (typeof this.effects[effect].init === 'function') {
			this.effects[effect].init(this);
		}

		return {
			slide: this.slide.bind(this),
			prev: this.prev.bind(this),
			next: this.next.bind(this),
			kill: this.kill.bind(this),
			reset: this.reset.bind(this)
			// reset: this.reset.bind(this)
		};
	};

	window.NinjaSlider.prototype = {
		///// configs
		setup: function setup() {
			this.width = this.container.getBoundingClientRect().width || this.container.offsetWidth;
			this.currentIndex = this.currentIndex ? this.currentIndex : 0;
			this.slidesPos = [];

			var effect = this.settings.effect;
			this.effects[effect].setup(this);
			this.initialized = true;
		},
		kill: function kill() {
			var effect = this.settings.effect;
			this.effects[effect].kill(this);
			this.initialized = false;
		},
		setupClosures: function setupClosures() {
			this.resize = this.onResize.bind(this);
			this.start = this.onStart.bind(this);
			this.move = this.onMove.bind(this);
			this.end = this.onEnd.bind(this);

			if (this.settings.auto) {
				this.stopAuto = function () {
					if (this.autoInterval) {
						clearInterval(this.autoInterval);
						this.autoInterval = undefined;
					}
					removeListeners(this.container, ['mousedown', 'touchstart', 'keydown'], this.stopAuto);
				}.bind(this);
			}

			if (this.settings.handleKeys) {
				this.keysHandler = function (event) {
					if (event.keyCode == '39') {
						this.next();
					} else if (event.keyCode == '37') {
						this.prev();
					}
				}.bind(this);
			}
		},
		reset: function reset() {
			clearInterval(this.autoInterval);
			// console.log('reset');

			var autotime = this.settings.auto;

			if (autotime) {
				this.autoInterval = setInterval(
				this.next.bind(this), autotime);

			}
		},
		eventsHandler: function eventsHandler(action) {
			if (action === 'engage') {
				// addListeners( this.list, ['touchstart', 'mousedown'], this.start );
				addListeners(this.list, ['touchstart'], this.start);
				// addListeners( this.list, ['mousedown', 'touchstart', 'keydown'], this.stopAuto );
				addListeners(this.list, ['touchstart', 'keydown'], this.stopAuto);

				if (this.settings.handleKeys) {
					document.addEventListener('keydown', this.keysHandler);
				}

				window.addEventListener('resize', this.resize);
			} else {
				// removeListeners( this.list, ['touchstart', 'mousedown'], this.start );
				removeListeners(this.list, ['touchstart'], this.start);
				// removeListeners( this.list, ['mousedown', 'touchstart', 'keydown'], this.stopAuto );
				removeListeners(this.list, ['touchstart', 'keydown'], this.stopAuto);

				if (this.settings.handleKeys) {
					document.removeEventListener('keydown', this.keysHandler);
				}

				window.removeEventListener('resize', this.resize);
			}
		},
		prev: function prev() {
			var target = this.currentIndex === 0 ? this.items.length - 1 : this.currentIndex - 1;
			var effect = this.settings.effect;
			this.effects[effect].slide(this, target);

			if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
				this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
			}
		},
		next: function next() {
			var target = this.currentIndex === this.items.length - 1 ? 0 : this.currentIndex + 1;
			var effect = this.settings.effect;
			this.effects[effect].slide(this, target, this.settings.speed);

			if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
				this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
			}
		},
		slide: function slide(to, time) {
			var effect = this.settings.effect;
			console.log();
			this.effects[effect].slide(this, to, time);

			if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
				this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
			}
		},

		///// delegations
		onResize: function onResize() {
			clearTimeout(this.resizeTimeout);
			// closure for the resize timeout
			// lets not kill performance
			this.resizeTimeout = setTimeout(function (ninjaSlider) {
				return function () {
					ninjaSlider.setup();
				};
			}(this), this.settings.throttle);
		},
		onStart: function onStart(event) {
			if (event.type === 'mousedown') {
				event.preventDefault();
			}

			var pointerCoors = getCoords(event);

			this.startPos = {
				x: pointerCoors.x,
				y: pointerCoors.y,
				time: new Date() };


			this.delta = {};

			this.isScrolling = undefined;

			var effect = this.settings.effect;
			if (typeof this.effects[effect].onStart === 'function') {
				this.effects[effect].onStart(this, pointerCoors, event);
			}

			addListeners(this.container, ['touchmove', 'mousemove'], this.move);
			addListeners(this.container, ['touchend', 'mouseup'], this.end);
		},
		onMove: function onMove(event) {
			var pointerCoors = getCoords(event);

			this.delta = {
				x: pointerCoors.x - this.startPos.x,
				y: pointerCoors.y - this.startPos.y };


			if (typeof this.isScrolling === 'undefined') {
				this.isScrolling = !!(this.isScrolling || Math.abs(this.delta.x) < Math.abs(this.delta.y));
			}

			if (this.isScrolling && !this.settings.blockScrolling) {
				return;
			}

			event.preventDefault();

			var effect = this.settings.effect;
			this.effects[effect].onMove(this, pointerCoors, event);
		},
		onEnd: function onEnd(event) {
			// event.preventDefault();

			var pointerCoors = getCoords(event);
			var duration = new Date() - this.startPos.time,
			direction = this.delta.x < 0,
			targetIndex = this.currentIndex;

			var isValidSlide = Number(duration) < 250 && Math.abs(this.delta.x) > 40 || Math.abs(this.delta.x) > this.width / 2,
			isPastBounds = !this.currentIndex && this.delta.x > 0 || this.currentIndex === this.items.length - 1 && this.delta.x < 0;

			if (isValidSlide && !isPastBounds) {
				targetIndex = direction ? this.currentIndex + 1 : this.currentIndex - 1;
			}

			var effect = this.settings.effect;
			if (typeof this.effects[effect].onEnd === 'function') {
				this.effects[effect].onEnd(this, pointerCoors, targetIndex, event);
			}

			if (typeof this.settings.transitionCallback === 'function' && this.items[this.currentIndex]) {
				this.settings.transitionCallback(this.currentIndex, this.items[this.currentIndex], this);
			}

			removeListeners(this.container, ['touchmove', 'mousemove'], this.move);
			removeListeners(this.container, ['touchend', 'mouseup'], this.end);
		},


		//// effects
		effects: {},

		// settings
		settings: {} };


	window.NinjaSlider.addEffect = function (effectName, effectObject) {
		NinjaSlider.prototype.effects[effectName] = effectObject;
	};

	// wrapper in jquery
	if (jQuery) {
		jQuery.fn.ninjaSlider = function (options) {
			if (this.data('ninjaSlider')) {
				return this.data('ninjaSlider');
			}
			return this.each(function () {
				$(this).data('ninjaSlider', new window.NinjaSlider(this, options));
			});
		};
	}
})(window, document);


/////////////////////////////////
///////////////////////////////// Effects
/////////////////////////////////

(function (window, document) {
	"use strict";

	var calcOffset = function calcOffset(width, index) {
		var calc = index * width * -1;
		if (index === 0) {
			calc = calc - width;
		}
		return calc;
	};

	var changeStyle = function changeStyle(element, props, value) {
		props.forEach(function (p) {
			element.style[p] = value;
		});
	};

	var move = function move(item, offset, speed) {
		changeStyle(item, ['webkitTransitionDuration', 'MozTransitionDuration', 'msTransitionDuration', 'transitionDuration'], speed + 'ms');
		changeStyle(item, ['webkitTransform', 'MozTransform', 'msTransform', 'transform'], 'translate(' + offset + 'px,0) translateZ(0)');
	};

	var closestNum = function closestNum(num, arr) {
		// si el array esta vacio se devuelve el numero
		if (!arr.length) {
			return num;
		}

		// si solo tiene un numero entonces
		// se devuelve el primero
		else if (arr.length === 1) {
				return arr[0];
			}

		var curr = arr[0],
		diff = Math.abs(num - curr);

		arr.forEach(function (n, index) {
			var newDiff = Math.abs(num - n);

			if (newDiff < diff) {
				diff = newDiff;
				curr = n;
			}
		});

		return curr;
	};

	/////////////////////////////////
	///////////////////////////////// Slide effect
	/////////////////////////////////
	window.NinjaSlider.addEffect('slide', {
		setup: function setup(ninjaSlider) {
			ninjaSlider.container.style.visibility = 'visible';
			changeStyle(ninjaSlider.container, ['webkitBackfaceVisibility', 'mozBackfaceVisibility', 'msBackfaceVisibility', 'backfaceVisibility'], 'hidden');
			changeStyle(ninjaSlider.container, ['webkitPerspective', 'mozPerspective', 'msPerspective', 'perspective'], 1000);
			ninjaSlider.list.style.width = ninjaSlider.width * ninjaSlider.items.length + 'px';

			ninjaSlider.items.forEach(function (item, i) {
				var offset_calc = calcOffset(ninjaSlider.width, i) + ninjaSlider.width;

				item.style.width = ninjaSlider.width + 'px';
				changeStyle(item, ['webkitTransform', 'MozTransform', 'msTransform', 'transform'], 'move(' + offset_calc + 'px,0) moveZ(0)');

				if (!ninjaSlider.initialized) {
					item.style.float = 'left';
					item.dataset.index = i;
					changeStyle(item, ['webkitTransitionDuration', 'MozTransitionDuration', 'msTransitionDuration', 'transitionDuration'], ninjaSlider.settings.speed + 'ms');
					item.dataset.offset = offset_calc;
					ninjaSlider.slidesPos.push(offset_calc);
				}
			});

			if (ninjaSlider.initialized) {
				ninjaSlider.effects[ninjaSlider.settings.effect].slide(ninjaSlider, ninjaSlider.currentIndex, 0);
			}
		},
		kill: function kill(ninjaSlider) {
			ninjaSlider.container.removeAttribute('style');
			ninjaSlider.list.removeAttribute('style');
			ninjaSlider.items.forEach(function (item) {
				item.removeAttribute('style');
			});
			ninjaSlider.eventsHandler('disengage');
			ninjaSlider.initialized = false;
		},
		slide: function slide(ninjaSlider, to, speed) {
			var current = ninjaSlider.currentIndex,
			items = ninjaSlider.items,
			width = ninjaSlider.width,
			prev = current < to ? current : to - 1,
			next = current > to ? current : to + 1,
			offset_prev,offset_target,offset_next;

			speed = typeof speed === 'undefined' ? ninjaSlider.settings.speed : speed;

			if (items[prev]) {
				offset_prev = calcOffset(ninjaSlider.width, prev);
				if (prev !== 0) {
					offset_prev = offset_prev - width;
				}

				move(items[prev], offset_prev, speed);
				ninjaSlider.slidesPos[prev] = offset_prev;
				items[prev].dataset.offset = offset_prev;
			}

			if (items[to]) {
				offset_target = calcOffset(ninjaSlider.width, to);
				if (to === 0) {
					offset_target = offset_target + width;
				}

				move(items[to], offset_target, speed);
				ninjaSlider.slidesPos[to] = offset_target;
				items[to].dataset.offset = offset_target;
			}

			if (items[next]) {
				offset_next = calcOffset(ninjaSlider.width, next) + width;
				move(items[next], offset_next, speed);
				ninjaSlider.slidesPos[next] = offset_next;
				items[next].dataset.offset = offset_next;
			}

			items.filter(function (el, i) {
				return i < to && i !== prev || i > to && i !== next;
			}).forEach(function (el) {
				var index = items.indexOf(el),
				direction = index > to,
				offset = calcOffset(ninjaSlider.width, index);

				if (index !== 0 && !direction) {
					offset = offset - width;
				} else if (direction) {
					offset = offset + width;
				}

				move(el, offset, 0);
				ninjaSlider.slidesPos[index] = offset;
				el.dataset.offset = offset;
			});

			ninjaSlider.currentIndex = to;
		},
		onMove: function onMove(ninjaSlider) {
			var slidesPos = ninjaSlider.slidesPos,
			prev = ninjaSlider.items[ninjaSlider.currentIndex - 1],
			current = ninjaSlider.items[ninjaSlider.currentIndex],
			next = ninjaSlider.items[ninjaSlider.currentIndex + 1],
			deltaX;

			ninjaSlider.delta.x = ninjaSlider.delta.x / (
			!ninjaSlider.currentIndex && ninjaSlider.delta.x > 0 ||
			ninjaSlider.currentIndex === ninjaSlider.items.length - 1 &&
			ninjaSlider.delta.x < 0 ?
			Math.abs(ninjaSlider.delta.x) / ninjaSlider.width + 1 : 1);

			deltaX = ninjaSlider.delta.x;

			if (prev) {
				move(prev, deltaX + slidesPos[ninjaSlider.currentIndex - 1], 0);
			}
			move(current, deltaX + slidesPos[ninjaSlider.currentIndex], 0);
			if (next) {
				move(next, deltaX + slidesPos[ninjaSlider.currentIndex + 1], 0);
			}
		},
		onEnd: function onEnd(ninjaSlider, pointerCoors, targetIndex, event) {
			ninjaSlider.effects[ninjaSlider.settings.effect].slide(ninjaSlider, targetIndex, ninjaSlider.settings.speed);
		} });




	/////////////////////////////////
	///////////////////////////////// carousel effect
	/////////////////////////////////
	window.NinjaSlider.addEffect('carousel', {
		setup: function setup(ninjaSlider) {
			// structure changes when is a carousel
			// one more layer added for scrolling items
			ninjaSlider.listHolder = ninjaSlider.container.children[0];
			ninjaSlider.list = ninjaSlider.listHolder.children[0];
			ninjaSlider.items = Array.prototype.map.call(ninjaSlider.list.children, function (e) {
				return e;
			});

			// ancho del contenedor de la lista
			ninjaSlider.holderWIdth = ninjaSlider.listHolder.getBoundingClientRect().width || ninjaSlider.listHolder.offsetWidth;

			ninjaSlider.listPos = 0;

			// numero maximo de items
			var maxItems = ninjaSlider.settings.itemsConf && ninjaSlider.settings.itemsConf.base || 5;

			if (ninjaSlider.settings.itemsConf && ninjaSlider.settings.itemsConf.medias) {
				ninjaSlider.settings.itemsConf.medias.forEach(function (mqinfo) {
					var breakpoint = mqinfo[0],
					itemsNum = mqinfo[1];

					if (window.matchMedia('screen and (max-width: ' + breakpoint + ')').matches) {
						maxItems = itemsNum;
					}
				});
			}

			var itemWidth;

			var jumpSlide = ninjaSlider.defaults.slideStart;
			var ip = maxItems;
			var div = 1;
			var cont = 0;

			// max items styles
			if (maxItems) {
				itemWidth = ninjaSlider.holderWIdth / maxItems;

				// seteo de estilos por item
				ninjaSlider.items.forEach(function (item, i) {
					//WATCH
					//jump slider
					if (jumpSlide) {
						ip = ip * div;
						if (i == ip) {
							cont++;
							div++;
						}
						item.dataset.index = cont;
					} else {
						item.dataset.index = i;
						changeStyle(item, ['min-width', 'width', 'max-width'], itemWidth + 'px');
					}
				});
			}

			// se indica el primer item como el activo
			ninjaSlider.items[0].dataset.current = true;

			// estilos bases para aceleracion gpu
			ninjaSlider.container.style.visibility = 'visible';
			changeStyle(ninjaSlider.container, ['webkitBackfaceVisibility', 'mozBackfaceVisibility', 'msBackfaceVisibility', 'backfaceVisibility'], 'hidden');
			changeStyle(ninjaSlider.container, ['webkitPerspective', 'mozPerspective', 'msPerspective', 'perspective'], 1000);

			// la lista debe ser relativa para que el.offsetLeft de el valor correcto
			ninjaSlider.list.style.position = 'relative';

			// la lista se vuelve del tamano de todos sus items
			ninjaSlider.listWIdth = itemWidth * ninjaSlider.items.length;
			ninjaSlider.list.style.width = ninjaSlider.listWIdth + 'px';

			// velocidad de transicion para la lista
			changeStyle(ninjaSlider.list, ['webkitTransitionDuration', 'MozTransitionDuration', 'msTransitionDuration', 'transitionDuration'], ninjaSlider.settings.speed + 'ms');
		},
		kill: function kill(ninjaSlider) {},
		slide: function slide(ninjaSlider, to, speed) {
			// si se requiere un index inexistente
			if (!ninjaSlider.items[to]) {
				console.warn('Se ingresó un index invalido o no existente: ', to);
				return;
			}

			// se indica el item activo
			ninjaSlider.items.forEach(function (item, i) {
				item.dataset.current = false;
			});
			ninjaSlider.items[to].dataset.current = true;
			// la lista se muevo solo en el caso de que el offset sea
			// menor a la resta del ancho del contenedor y de la lista
			ninjaSlider.listPos = ninjaSlider.items[to].offsetLeft;
			if (ninjaSlider.listPos > ninjaSlider.listWIdth - ninjaSlider.holderWIdth) {
				ninjaSlider.listPos = ninjaSlider.listWIdth - ninjaSlider.holderWIdth;
			}

			ninjaSlider.listPos = ninjaSlider.listPos * -1;

			move(ninjaSlider.list, ninjaSlider.listPos, speed || ninjaSlider.settings.speed);

			// se indica el nuevo index
			ninjaSlider.currentIndex = to;
		},
		onMove: function onMove(ninjaSlider) {
			var isLeftBound = ninjaSlider.listPos >= 0 && ninjaSlider.delta.x > 0;
			var isRightBound = Math.abs(ninjaSlider.listPos) >= ninjaSlider.listWIdth - ninjaSlider.holderWIdth && ninjaSlider.delta.x < 0;
			var isInBounds = isLeftBound || isRightBound;

			// resistencia de arrastre en los bordes
			ninjaSlider.delta.x = ninjaSlider.delta.x / (isInBounds ? Math.abs(ninjaSlider.delta.x) / ninjaSlider.holderWIdth + 3 : 1);

			ninjaSlider.movementPos = ninjaSlider.delta.x + ninjaSlider.listPos;

			move(ninjaSlider.list, ninjaSlider.movementPos, 0);
		},
		onEnd: function onEnd(ninjaSlider, pointerCoors, targetIndex, event) {
			var isLeftBound = ninjaSlider.movementPos > 0;
			var isRightBound = Math.abs(ninjaSlider.movementPos) >= ninjaSlider.listWIdth - ninjaSlider.holderWIdth;

			// si es mayor a 0
			// borde izquierdo
			if (isLeftBound) {
				ninjaSlider.movementPos = 0;
			}

			// si es mayor al borde derecho
			else if (isRightBound) {
					ninjaSlider.movementPos = (ninjaSlider.listWIdth - ninjaSlider.holderWIdth) * -1;
				}

				// en cualquier otro caso
				// la posicion final se iguala al offset del elemento mas cercano del Delta del movimiento
				else {
						var positions = [];

						ninjaSlider.items.forEach(function (item, i) {
							positions.push(item.offsetLeft);
						});

						ninjaSlider.movementPos = closestNum(Math.abs(ninjaSlider.movementPos), positions) * -1;
					}

			move(ninjaSlider.list, ninjaSlider.movementPos, ninjaSlider.settings.speed);
			ninjaSlider.listPos = ninjaSlider.movementPos;
		} });

})(window, document);
'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};(function (window, document) {
    "use strict";

    // merges objects and overrides properties of the target object
    var extend = function extend(target, source) {
        var a = Object.create(target);
        Object.keys(source).map(function (prop) {
            prop in a && (a[prop] = source[prop]);
        });
        return a;
    };

    // test if a given element matches a css selector
    var matchesSelector = function matchesSelector(selector, element) {
        var matches = (element.document || element.ownerDocument).querySelectorAll(selector);
        var i = 0;

        while (matches[i] && matches[i] !== element) {
            i++;
        }

        return matches[i] ? true : false;
    };

    // vanilla similar of jQuery.on()
    // multiple arguments model
    // v1 : events (String), element (node), callback (function) ---- directly delegates callback
    // v2 : events (String), element (node), data (object), callback (function) ---- directly delegates callback
    // v3 : events (String), element (node), selector (string), data (object), callback (function) ---- delegates event to one parent
    var on = function on() {
        if (!arguments || !arguments.length) {return;}

        var events = arguments[0],
        element = arguments[1],
        data = {},
        childrenSelectors,callback;

        if (_typeof(arguments[2]) === 'object') {
            data = arguments[2];
            callback = arguments[3];
        } else
        if (typeof arguments[2] === 'function') {
            callback = arguments[2];
        } else
        if (typeof arguments[2] === 'string') {
            childrenSelectors = arguments[2];

            if (_typeof(arguments[3]) === 'object') {
                data = arguments[3];
                callback = arguments[4];
            } else
            if (typeof arguments[3] === 'function') {
                callback = arguments[3];
            }
        }

        events.split(' ').forEach(function (ev) {
            element.addEventListener(ev, function (event) {
                event.data = data;

                if (childrenSelectors && event.target && matchesSelector(childrenSelectors, event.target)) {
                    callback.bind(event.target)(event);
                } else {
                    callback.bind(element)(event);
                }
            }, false);
        });
    };

    var toRealArray = function toRealArray(arrayLike) {
        return arrayLike ? Array.prototype.map.call(arrayLike, function (v) {return v;}) : [];
    };

    window.Validizr = function (form, options) {
        if (!form) {return;} // safety first

        // create the defaults and allow for custom options
        this.defaults = {
            validateOnInit: false, // bool, activa/desactiva la validacion en la inicializacion
            delegate_change: true, // bool, controla la delegacion de la validacion en los campos
            delegate_keyup: true, // bool, controla la delegacion de la validacion en los campos

            onInit: undefined, // callback para despues de la inicialiacion del plugin

            validFormCallback: undefined, // funcion, lleva como parametro el $formulario
            notValidFormCallBack: undefined, // funcion, lleva como parametro el $formulario

            validInputCallback: undefined, // funcion, lleva como parametro el $input
            notValidInputCallback: undefined, // funcion, lleva como parametro el $input

            preValidation: undefined, // funcion, lleva como parametro el $formulario y el $input
            postValidation: undefined, // funcion, lleva como parametro el $formulario y el $input

            notValidClass: 'invalid-input', // string, clase a aplicar a los inputs no validos
            validClass: 'valid-input', // string, clase a aplicar a los inputs no validos

            aditionalInputs: undefined, // string, selector para inputs customizados

            customValidations: {}, // objeto, prototipo para las validaciones customizadas. 
            customValidHandlers: {}, // objeto, prototipo para los exitos customizados. 
            customErrorHandlers: {} // objeto, prototipo para los errores customizados. 
        };
        this.settings = extend(this.defaults, options || {});

        // identify the form element
        if (typeof form === 'string') {
            this.form = document.querySelector(form);
        } else
        if (form.nodeType) {
            this.form = form;
        }

        this.emailRegEx = /[\w\d-_.]+@[\w\d-_.]+\.[\w]{2,10}$/;
        this.urlRegEx = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;

        // cache selectors
        this.inputs_selector = 'input:not([type="submit"]):not([type="reset"]), select, textarea';
        if (this.settings.aditionalInputs) {
            this.inputs_selector += ' ' + this.settings.aditionalInputs;
        }

        // disable html5 validation
        this.form.noValidate = true;
        this.form.dataset.validizrHandled = true;

        // delegate events
        var events = 'validizrValidate';
        if (this.settings.delegate_change) {events += ' change';}
        if (this.settings.delegate_keyup) {events += ' keyup';}

        on(events, this.form, this.inputs_selector, { validizr: this }, this.validateInputs);
        on('submit', this.form, { validizr: this }, this.validateForm);

        // trigger validation on init if set
        if (this.settings.validateOnInit) {
            this.validate();
        }

        // fire init callback if exist
        if (typeof this.settings.onInit === 'function') {
            this.settings.onInit(this.form, this);
        }

        // return plain object with useful functions
        return {
            validate: this.validate.bind(this),
            getStatus: this.getStatus.bind(this) };

    };
    window.Validizr.prototype = {
        validateInputs: function validateInputs(event) {
            var input = this,
            validizr = event.data.validizr,
            inputType = validizr.getInputType(input),
            customHandler = input.getAttribute('data-custom-validation'),
            value = input.value,
            validInput = function () {
                var isRequired = input.required || typeof input.getAttribute('required') !== 'undefined';
                if (!isRequired && !input.classList.contains('required')) {return true;}
                if (!!customHandler && typeof validizr.settings.customValidations[customHandler] === 'function') {
                    return validizr.settings.customValidations[customHandler](input, validizr, event);
                }
                switch (inputType) {
                    case 'email':return !!value && validizr.emailRegEx.test(value);
                    case 'url':return !!value && validizr.urlRegEx.test(value);
                    case 'checkbox':return input.checked;
                    default:return !!value;}

            }();

            if (input.classList.contains(validizr.settings.notValidClass) || input.classList.contains(validizr.settings.validClass)) {
                input.classList.remove(validizr.settings.notValidClass);
                input.classList.remove(validizr.settings.validClass);
            }

            if (typeof validizr.settings.preValidation === 'function') {validizr.settings.preValidation(validizr.form, input);}

            validizr.youAre(validInput, input);

            if (typeof validizr.settings.postValidation === 'function') {validizr.settings.postValidation(validizr.form, input);}
        },
        validateForm: function validateForm(event) {
            var validizr = event.data.validizr,
            isValid = false;

            validizr.validate();
            isValid = validizr.isFormValid();

            if (isValid) {
                if (typeof validizr.settings.validFormCallback === 'function') {
                    event.preventDefault();
                    validizr.settings.validFormCallback(validizr.form);
                    if (validizr.form.dataset.nativeSubmit) {
                        return true;
                    }
                    return false;
                }
                return true;
            } else
            if (typeof validizr.settings.notValidFormCallBack === 'function') {
                validizr.settings.notValidFormCallBack(validizr.form);
            }

            event.preventDefault();
            return false;
        },
        isFormValid: function isFormValid() {
            var fields = toRealArray(this.form.querySelectorAll(this.inputs_selector)),
            totalLength = fields.length,
            validLength = fields.filter(function (input) {return input.dataset.validizrValidity;}).length,
            softValidation = toRealArray(this.form.querySelectorAll('.' + this.settings.notValidClass)).length;
            return totalLength === validLength && !softValidation;
        },
        youAre: function youAre(validity, input) {
            var customHandler_invalid = input.getAttribute('data-custom-invalid-callback'),
            customHandler_valid = input.getAttribute('data-custom-valid-callback');

            input.dataset.validizrValidity = validity;

            if (validity) {
                input.classList.add(this.settings.validClass);

                if (typeof this.settings.customValidHandlers[customHandler_valid] === 'function') {
                    this.settings.customValidHandlers[customHandler_valid](input);
                }
                if (typeof this.settings.validInputCallback === 'function') {
                    this.settings.validInputCallback(input);
                }
            } else {
                input.classList.add(this.settings.notValidClass);

                if (typeof this.settings.customErrorHandlers[customHandler_invalid] === 'function') {
                    this.settings.customErrorHandlers[customHandler_invalid](input);
                }
                if (typeof this.settings.notValidInputCallback === 'function') {
                    this.settings.notValidInputCallback(input);
                }
            }
        },
        getInputType: function getInputType(input) {
            return input.type ? input.type.toLowerCase() : input.tagName.toLowerCase();
        },
        validate: function validate(selector) {
            var inputs = toRealArray(this.form.querySelectorAll(selector || this.inputs_selector));
            inputs.forEach(function (input) {
                var validation_event = document.createEvent("Event");
                validation_event.initEvent("validizrValidate", true, true);
                input.dispatchEvent(validation_event);
            });

            return this.getStatus();
        },
        getStatus: function getStatus() {
            var fields = toRealArray(this.form.querySelectorAll(this.inputs_selector));
            return {
                validity: this.isFormValid(),
                invalidInputs: fields.filter(function (input) {return !input.dataset.validizrValidity;}),
                validInputs: fields.filter(function (input) {return input.dataset.validizrValidity;}) };

        } };

})(window, document);
'use strict';$(document).ready(function () {

  $('.ad-event').on('click', function () {
    var tabActive = $('.form-pasos--button.active').data('target');
    var tabNext = $(this).data('target');
    var button = $(this);
    button.addClass('button--loading');

    if (tabActive == 'postulacion-alumno')
    validate_admision_alumno(button, tabNext);

    if (tabActive == 'postulacion-apoderado')
    validate_admision_apoderado(button, tabNext);

    return false;
  });

  function validate_admision_alumno(button, tabNext) {
    var tab = $('.form-pasos--target[data-tabname=postulacion-alumno]');
    var formData = $('#postulacion-alumno').serializeArray();
    formData.push({ name: 'form', value: 'alumno' });
    console.log(formData);
    $.ajax({ url: data.base_url + 'postulacion', method: "POST", data: $.param(formData) }).
    done(function (json) {
      json = JSON.parse(json);
      var input = [];
      if (json.code == 422) {
        console.log(json);
        for (input in json.data) {
          $('[name=' + input + ']').addClass('invalid-input').parents('.form-control').attr('data-error-message', json.data[input]).addClass('form-control--invalid');
          $('[name=' + input + ']').siblings('.form-control__text').hide();
          removeClass($('[name=' + input + ']'));
        }
      }
      if (json.code == 200) {
        tab.data('validate', true);
        nextTab(tabNext);
      }

      button.removeClass('button--loading');
    });
  }

  function validate_admision_apoderado(button, tabNext) {
    var tab = $('.form-pasos--target[data-tabname=postulacion-apoderado]');
    var formData = $('#postulacion-alumno').serializeArray();
    formData = formData.concat($('#postulacion-apoderado').serializeArray());
    formData.push({ name: 'form', value: 'all' });
    console.log(formData);
    $.ajax({ url: data.base_url + 'postulacion', method: "POST", data: $.param(formData) }).
    done(function (json) {
      json = JSON.parse(json);
      var input = [];
      if (json.code == 422) {
        for (input in json.data) {
          $('#postulacion-apoderado [name=' + input + ']').addClass('invalid-input').parents('.form-control').attr('data-error-message', json.data[input]).addClass('form-control--invalid');
          $('#postulacion-apoderado [name=' + input + ']').siblings('.form-control__text').hide();
          removeClass($('#postulacion-apoderado [name=' + input + ']'));
        }
      }
      if (json.code == 200) {
        $('#postulacion-apoderado').hide();
        $('.form-response').show();
        $('.form-response').addClass('exito');
        $('.form-response__title').append('¡Muchas gracias por su postulación!');
        $('.form-response__excerpt').append(json.msg);

        $('[data-func="showTab"]').attr('style', 'pointer-events: none');
      }

      if (json.code == 500) {
        $('#postulacion-apoderado').hide();
        $('.form-response').show();
        $('.form-response').addClass('error');
        $('.form-response__title').append('¡Lo sentimos, tu mensaje no ha podido ser enviado!');
        $('.form-response__excerpt').append(json.msg);
      }

      button.removeClass('button--loading');
    });
  }

  function nextTab(tabNext) {
    $('.form-pasos--target.active').removeClass('active');
    $('.form-pasos--button.active').removeClass('active');

    $('.form-pasos--target[data-tabname=' + tabNext + ']').addClass('active');
    $('.form-pasos--button[data-target=' + tabNext + ']').addClass('active');
  }

  $('select[name=curso]').on('change', function () {
    var curso = $(this).val();
  });

  function removeClass(input) {
    setTimeout(function () {
      input.siblings('.form-control__text').show(); //added
      input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
    }, 4000);
  }
});
'use strict';(function (window, document, $) {
   "use strict";

   var AudioPlay = function AudioPlay(element) {
      this.$audio = $(element);
      this.$audioElement = document.createElement('audio');

      this.$audiosrc = this.$audio.data('target');
      this.$audioElement.setAttribute('src', this.$audiosrc);

      this.$playbutton = this.$audio.find('[data-role="button-play"]');
      this.$pausebutton = this.$audio.find('[data-role="button-pause"]');
      this.$playbutton.on('click', this.playAudio.bind(this));
      this.$pausebutton.on('click', this.pauseAudio.bind(this));
      return this;
   };

   AudioPlay.prototype = {
      playAudio: function playAudio(event) {
         event.preventDefault();
         this.$audioElement.play();
         this.$playbutton.toggleClass('remove');
         this.$pausebutton.toggleClass('remove');
      },
      pauseAudio: function pauseAudio(event) {
         event.preventDefault();
         this.$audioElement.pause();
         this.$pausebutton.toggleClass('remove');
         this.$playbutton.toggleClass('remove');
      } };


   $.fn.audio = function () {
      if (this.data('audio')) {
         return this.data('audio');
      }
      return this.each(function (i, el) {
         $(el).data('audio', new AudioPlay(el));
      });
   };

   $('[data-module="audio"]').audio();

})(window, document, jQuery);
'use strict'; //////////////////////
////////////////////// Common Carousel
//////////////////////
(function (window, document, $) {
	"use strict";

	// check for NinjaSlider dependency
	if (typeof NinjaSlider === 'undefined') {
		console.log('Error: NinjaSlider is required');
		return;
	}

	var CommonCarousel = function CommonCarousel(element) {
		this.container = element;
		this.$container = $(element);
		this.$slide = $(element).data('slide') || false;
		this.$slides = this.$container.find('[data-role="carousel-slide"]');
		this.$arrows = this.$container.find('[data-role="carousel-arrow"]');

		this.ninjaSlider = new NinjaSlider(this.container, {
			auto: false,
			effect: 'carousel',
			itemsConf: this.parseOptions(),
			slideStart: false });


		this.$arrows.on('click.CommonCarousel', this.arrowCallback.bind(this));
	};
	CommonCarousel.prototype = {
		arrowCallback: function arrowCallback(event) {
			event.preventDefault();
			var $btn = $(event.currentTarget),
			direction = $btn.data('direction');
			this.ninjaSlider[direction]();
		},

		parseOptions: function parseOptions() {
			var itemsConf = {},
			mqitems = [];

			itemsConf.base = this.$container.data('maxitems') && parseFloat(this.$container.data('maxitems')) || 5;

			if (this.$container.data('mqitems')) {
				this.$container.data('mqitems').split('|').forEach(function (textInfo) {
					var data = textInfo.split(',');
					mqitems.push([data[0], parseFloat(data[1])]);
				});

				itemsConf.medias = mqitems;
			}

			return itemsConf;
		} };


	$.fn.commonCarousel = function () {
		if (this.data('commonCarousel')) {return this.data('commonCarousel');}
		return this.each(function (i, el) {
			$(el).data('commonCarousel', new CommonCarousel(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="carousel"]').commonCarousel();
	});

})(window, document, jQuery);
'use strict';$(document).ready(function () {

  $('body').on('click', '#btn-form-contact', function () {
    var formData = $('#admision-contacto').serializeArray();
    formData.push({ name: 'action', value: 'form-ajax-nonce' });
    formData.push({ name: 'security', value: $('#form-ajax-nonce').val() });

    $('#btn-form-contact').addClass('button--loading');
    console.log(formData);
    $.post(data.base_url + 'contact', $.param(formData), function (json) {

      json = JSON.parse(json);
      var input = [];

      if (json.code == 422) {
        for (input in json.data) {
          $('[name=' + input + ']').addClass('invalid-input').parents('.form-control').attr('data-error-message', json.data[input]).addClass('form-control--invalid');
          $('[name=' + input + ']').siblings('.form-control__text').hide();
          removeClass($('[name=' + input + ']'));
        }
      }

      if (json.code == 200) {
        $('#admision-contacto').hide();
        $('.form-response').show();
        $('.form-response').addClass('exito');
        $('.form-response__title').append('¡Tu mensaje ha sido enviado con éxito!');
        $('.form-response__excerpt').append(json.msg);
      }

      if (json.code == 500) {
        $('#admision-contacto').hide();
        $('.form-response').show();
        $('.form-response').addClass('error');
        $('.form-response__title').append('¡Lo sentimos, tu mensaje no ha podido ser enviado!');
        $('.form-response__excerpt').append(json.msg);
      }

      $('#btn-form-contact').removeClass('button--loading');
    });
    return false;
  });


  function removeClass(input) {
    setTimeout(function () {
      input.siblings('.form-control__text').show(); //added
      input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
    }, 4000);
  }
});
"use strict";var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;}; /*!
                                                                                                                                                                                                                                                                                        * enquire.js v2.1.6 - Awesome Media Queries in JavaScript
                                                                                                                                                                                                                                                                                        * Copyright (c) 2017 Nick Williams - http://wicky.nillia.ms/enquire.js
                                                                                                                                                                                                                                                                                        * License: MIT */


(function (f) {
	if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
		module.exports = f();
	} else if (typeof define === "function" && define.amd) {
		define([], f);
	} else {
		var g;
		if (typeof window !== "undefined") {
			g = window;
		} else if (typeof global !== "undefined") {
			g = global;
		} else if (typeof self !== "undefined") {
			g = self;
		} else {
			g = this;
		}
		g.enquire = f();
	}
})(function () {
	var define, module, exports;
	return function e(t, n, r) {
		function s(o, u) {
			if (!n[o]) {
				if (!t[o]) {
					var a = typeof require == "function" && require;
					if (!u && a) return a(o, !0);
					if (i) return i(o, !0);
					var f = new Error("Cannot find module '" + o + "'");
					throw f.code = "MODULE_NOT_FOUND", f;
				}
				var l = n[o] = {
					exports: {} };

				t[o][0].call(l.exports, function (e) {
					var n = t[o][1][e];
					return s(n ? n : e);
				}, l, l.exports, e, t, n, r);
			}
			return n[o].exports;
		}
		var i = typeof require == "function" && require;
		for (var o = 0; o < r.length; o++) {s(r[o]);}
		return s;
	}({
		1: [function (require, module, exports) {
			var QueryHandler = require(3);
			var each = require(4).each;

			/**
                                * Represents a single media query, manages it's state and registered handlers for this query
                                *
                                * @constructor
                                * @param {string} query the media query string
                                * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
                                */
			function MediaQuery(query, isUnconditional) {
				this.query = query;
				this.isUnconditional = isUnconditional;
				this.handlers = [];
				this.mql = window.matchMedia(query);

				var self = this;
				this.listener = function (mql) {
					// Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
					self.mql = mql.currentTarget || mql;
					self.assess();
				};
				this.mql.addListener(this.listener);
			}

			MediaQuery.prototype = {

				constuctor: MediaQuery,

				/**
                             * add a handler for this query, triggering if already active
                             *
                             * @param {object} handler
                             * @param {function} handler.match callback for when query is activated
                             * @param {function} [handler.unmatch] callback for when query is deactivated
                             * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
                             * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
                             */
				addHandler: function addHandler(handler) {
					var qh = new QueryHandler(handler);
					this.handlers.push(qh);

					this.matches() && qh.on();
				},

				/**
        * removes the given handler from the collection, and calls it's destroy methods
        *
        * @param {object || function} handler the handler to remove
        */
				removeHandler: function removeHandler(handler) {
					var handlers = this.handlers;
					each(handlers, function (h, i) {
						if (h.equals(handler)) {
							h.destroy();
							return !handlers.splice(i, 1); //remove from array and exit each early
						}
					});
				},

				/**
        * Determine whether the media query should be considered a match
        *
        * @return {Boolean} true if media query can be considered a match, false otherwise
        */
				matches: function matches() {
					return this.mql.matches || this.isUnconditional;
				},

				/**
        * Clears all handlers and unbinds events
        */
				clear: function clear() {
					each(this.handlers, function (handler) {
						handler.destroy();
					});
					this.mql.removeListener(this.listener);
					this.handlers.length = 0; //clear array
				},

				/*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
				assess: function assess() {
					var action = this.matches() ? 'on' : 'off';

					each(this.handlers, function (handler) {
						handler[action]();
					});
				} };


			module.exports = MediaQuery;

		}, {
			"3": 3,
			"4": 4 }],

		2: [function (require, module, exports) {
			var MediaQuery = require(1);
			var Util = require(4);
			var each = Util.each;
			var isFunction = Util.isFunction;
			var isArray = Util.isArray;

			/**
                                * Allows for registration of query handlers.
                                * Manages the query handler's state and is responsible for wiring up browser events
                                *
                                * @constructor
                                */
			function MediaQueryDispatch() {
				if (!window.matchMedia) {
					throw new Error('matchMedia not present, legacy browsers require a polyfill');
				}

				this.queries = {};
				this.browserIsIncapable = !window.matchMedia('only all').matches;
			}

			MediaQueryDispatch.prototype = {

				constructor: MediaQueryDispatch,

				/**
                                      * Registers a handler for the given media query
                                      *
                                      * @param {string} q the media query
                                      * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
                                      * @param {function} options.match fired when query matched
                                      * @param {function} [options.unmatch] fired when a query is no longer matched
                                      * @param {function} [options.setup] fired when handler first triggered
                                      * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
                                      * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
                                      */
				register: function register(q, options, shouldDegrade) {
					var queries = this.queries,
					isUnconditional = shouldDegrade && this.browserIsIncapable;

					if (!queries[q]) {
						queries[q] = new MediaQuery(q, isUnconditional);
					}

					//normalise to object in an array
					if (isFunction(options)) {
						options = {
							match: options };

					}
					if (!isArray(options)) {
						options = [options];
					}
					each(options, function (handler) {
						if (isFunction(handler)) {
							handler = {
								match: handler };

						}
						queries[q].addHandler(handler);
					});

					return this;
				},

				/**
        * unregisters a query and all it's handlers, or a specific handler for a query
        *
        * @param {string} q the media query to target
        * @param {object || function} [handler] specific handler to unregister
        */
				unregister: function unregister(q, handler) {
					var query = this.queries[q];

					if (query) {
						if (handler) {
							query.removeHandler(handler);
						} else {
							query.clear();
							delete this.queries[q];
						}
					}

					return this;
				} };


			module.exports = MediaQueryDispatch;

		}, {
			"1": 1,
			"4": 4 }],

		3: [function (require, module, exports) {
			/**
                                            * Delegate to handle a media query being matched and unmatched.
                                            *
                                            * @param {object} options
                                            * @param {function} options.match callback for when the media query is matched
                                            * @param {function} [options.unmatch] callback for when the media query is unmatched
                                            * @param {function} [options.setup] one-time callback triggered the first time a query is matched
                                            * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
                                            * @constructor
                                            */
			function QueryHandler(options) {
				this.options = options;
				!options.deferSetup && this.setup();
			}

			QueryHandler.prototype = {

				constructor: QueryHandler,

				/**
                                * coordinates setup of the handler
                                *
                                * @function
                                */
				setup: function setup() {
					if (this.options.setup) {
						this.options.setup();
					}
					this.initialised = true;
				},

				/**
        * coordinates setup and triggering of the handler
        *
        * @function
        */
				on: function on() {
					!this.initialised && this.setup();
					this.options.match && this.options.match();
				},

				/**
        * coordinates the unmatch event for the handler
        *
        * @function
        */
				off: function off() {
					this.options.unmatch && this.options.unmatch();
				},

				/**
        * called when a handler is to be destroyed.
        * delegates to the destroy or unmatch callbacks, depending on availability.
        *
        * @function
        */
				destroy: function destroy() {
					this.options.destroy ? this.options.destroy() : this.off();
				},

				/**
        * determines equality by reference.
        * if object is supplied compare options, if function, compare match callback
        *
        * @function
        * @param {object || function} [target] the target for comparison
        */
				equals: function equals(target) {
					return this.options === target || this.options.match === target;
				} };



			module.exports = QueryHandler;

		}, {}],
		4: [function (require, module, exports) {
			/**
                                            * Helper function for iterating over a collection
                                            *
                                            * @param collection
                                            * @param fn
                                            */
			function each(collection, fn) {
				var i = 0,
				length = collection.length,
				cont;

				for (i; i < length; i++) {
					cont = fn(collection[i], i);
					if (cont === false) {
						break; //allow early exit
					}
				}
			}

			/**
      * Helper function for determining whether target object is an array
      *
      * @param target the object under test
      * @return {Boolean} true if array, false otherwise
      */
			function isArray(target) {
				return Object.prototype.toString.apply(target) === '[object Array]';
			}

			/**
      * Helper function for determining whether target object is a function
      *
      * @param target the object under test
      * @return {Boolean} true if function, false otherwise
      */
			function isFunction(target) {
				return typeof target === 'function';
			}

			module.exports = {
				isFunction: isFunction,
				isArray: isArray,
				each: each };


		}, {}],
		5: [function (require, module, exports) {
			var MediaQueryDispatch = require(2);
			module.exports = new MediaQueryDispatch();

		}, {
			"2": 2 }] },

	{}, [5])(5);
});
'use strict'; /******************
              MIT License
              
              Copyright (c) 2016 Fernando Silva Müller (@fdograph)
              
              Permission is hereby granted, free of charge, to any person obtaining a copy
              of this software and associated documentation files (the "Software"), to deal
              in the Software without restriction, including without limitation the rights
              to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              copies of the Software, and to permit persons to whom the Software is
              furnished to do so, subject to the following conditions:
              
              The above copyright notice and this permission notice shall be included in all
              copies or substantial portions of the Software.
              
              THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              SOFTWARE.
              
              Chilean RUT validator written in VanillaJS
              ******************/
(function (window, document) {
	"use strict";

	var NinjaRut = function NinjaRut(protoRut) {
		this.protoRut = protoRut;
		this.cleanRut = this.clean();
		this.process();
		return this;
	};
	NinjaRut.prototype = {
		clean: function clean() {
			var allowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'k'];

			// clean the proto rut by removing forbidden characters
			var clean = Array.prototype.map.call(this.protoRut.toLowerCase(), function (c) {
				return c;
			});
			clean = clean.filter(function (c) {
				return allowed.indexOf(c) !== -1;
			});

			return clean.join('');
		},

		process: function process() {
			this.number = this.cleanRut.substring(0, this.cleanRut.length - 1);
			this.digit = this.cleanRut.charAt(this.cleanRut.length - 1);
			this.isValid = this.validate();
		},

		getDigit: function getDigit() {
			var sum = 0,
			mul = 2,
			res;

			var i = this.number.length;

			while (i--) {
				sum = sum + parseInt(this.number.charAt(i)) * mul;
				if (mul % 7 === 0) {
					mul = 2;
				} else {
					mul++;
				}
			}

			res = sum % 11;
			if (res === 0) {
				return '0';
			} else if (res === 1) {
				return 'k';
			} else {
				return 11 - res;
			}
		},

		validate: function validate() {
			// if too short
			if (this.cleanRut.length < 6) {
				return false;
			}

			// if impossible ruts(but valid tho)
			// Eg: 11111111-1
			if (this.cleanRut.match(/(\d)\1{7,9}/)) {
				return false;
			}

			// math validation
			if (this.digit != this.getDigit()) {
				return false;
			}

			return true;
		},

		format: function format(dots) {
			var formatedNum = dots ? this.number.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") : this.number;
			return formatedNum + '-' + this.digit;
		} };


	window.NinjaRut = NinjaRut;
})(window, document);

(function (window, document, $) {
	"use strict";

	// check for Validizr dependency
	if (typeof Validizr === 'undefined') {
		console.log('Error: Validizr is required');
		return;
	}

	/////////////////////////////////////////
	///////////////////////////////////////// CommonForm Module
	/////////////////////////////////////////

	var CommonForm = function CommonForm(form) {
		this.form = form;
		var self = this;
		var func = form.getAttribute('data-validation') || false;

		this.validizr = new Validizr(this.form, {
			validInputCallback: this.validInputAction,
			notValidInputCallback: this.invalidInputAction,
			customValidations: this.customValidations,
			validFormCallback: $.proxy(self[func], self) });

		return this;
	};
	CommonForm.prototype = {
		validInputAction: function validInputAction(input) {
			if ($(input).prop('required') || $(input).prop('data-validate-me')) {
				$(input).addClass('valid-input');
				$(input).parents('.form-control').addClass('valid-control').removeClass('invalid-control');
			} else {
				$(input).removeClass('valid-input');
				$(input).parents('.form-control').removeClass('valid-control');
			}
		},
		invalidInputAction: function invalidInputAction(input) {
			if ($(input).prop('required') || $(input).prop('data-validate-me')) {
				$(input).addClass('invalid-input');
				$(input).parents('.form-control').addClass('invalid-control').removeClass('valid-control');
			} else {
				$(input).removeClass('invalid-input');
				$(input).parents('.form-control').removeClass('invalid-control');
			}
		},
		generic_submit: function generic_submit($form) {
			var $this = $($form);
			var $parent = $($this.data('parent'));
			var submit_class = $this.data('submit-class');

			$parent.addClass(submit_class);
			$form.submit();
		},
		generic_ajax: function generic_ajax($form) {
			var $this = $($form);
			var $parent = $($this.data('parent'));
			var submit_class = $this.data('submit-class'),
			formData = new FormData($form);

			$parent.addClass(submit_class);

			$.ajax({
				url: $this.attr('action'),
				type: $this.attr('method'),
				data: formData,
				dataType: "json",
				cache: false,
				contentType: false,
				processData: false,
				success: function success(response) {
					console.log('success');
					console.log(response);
					if (response.status == 'success') {
						$parent.removeClass(submit_class);
						$parent.html(response.response_html);
					} else {
						$parent.removeClass(submit_class);
						$parent.html(response.response_html);
					}
				},
				error: function error(response) {
					console.log('error');
					console.log(response);
				} });

		},
		customValidations: {

			onlyNumbers: function onlyNumbers(input, validizr, event) {
				var $input = $(input),
				value = $input.val(),
				cleanValue = value.replace(/\D/g, ''),
				minLength = $input.data('minlength') || false,
				maxLength = $input.data('maxlength') || false;

				// force clean value to input
				$input.val(cleanValue);

				// only act on required fields
				// if no value and not required
				if (!cleanValue && !$input.prop('required')) {
					return true;
				}

				// value validation

				// if no value after cleaning
				if (!cleanValue) {
					return false;
				}

				// if less than specified minimun length
				if (minLength && cleanValue.length < minLength) {
					return false;
				}

				// if more than specified maximum length
				if (maxLength && cleanValue.length > maxLength) {
					return false;
				}

				// return value based boolean
				return !!cleanValue;
			},

			onlyString: function onlyString(input, validizr, event) {
				var $input = $(input),
				value = $input.val(),
				cleanValue = value.replace(/\d/g, ''),
				minLength = $input.data('minlength') || false,
				maxLength = $input.data('maxlength') || false;

				// force clean value to input
				$input.val(cleanValue);

				// only act on required fields
				// if no value and not required
				if (!cleanValue && !$input.prop('required')) {
					return true;
				}

				// value validation

				// if no value after cleaning
				if (!cleanValue) {
					return false;
				}

				// if less than specified minimun length
				if (minLength && cleanValue.length < minLength) {
					return false;
				}

				// if more than specified maximum length
				if (maxLength && cleanValue.length > maxLength) {
					return false;
				}

				// return value based boolean
				return !!cleanValue;
			},

			equalTo: function equalTo(input, validizr, event) {
				var $input = $(input),
				inputType = validizr.getInputType(input),
				value = $input.val(),
				sample = $('#' + $input.data('sample')).val();

				// value validation

				// check if any is empty
				if (!value || !sample) {
					return false;
				}

				// check if is email depending on input type
				if (inputType === 'email') {
					//if email input and any of the values isnt an email
					if (!validizr.emailRegEx.test(value) || !validizr.emailRegEx.test(sample)) {
						return false;
					}
				}

				// check if both values are equal
				if (value !== sample) {
					return false;
				}

				// return value based boolean
				return !!value;
			},

			matchPattern: function matchPattern(input, validizr, event) {
				var $input = $(input),
				value = $input.val(),
				protoPattern = $input.data('pattern'),
				pattern = new RegExp(protoPattern);

				// value validation

				// if no value
				if (!value) {
					return false;
				}

				// return regexp based boolean
				return pattern.test(value);
			},

			validRut: function validRut(input, validizr, event) {
				var $input = $(input),
				rut = new NinjaRut($input.val().trim());

				// value validation
				if (!rut.isValid) {
					return false;
				}

				// if autoformat is specified
				if ($input.data('autoformat')) {
					$input.val(rut.format(true));
				}

				// if it passes is considered valid
				return true;
			},

			fileValidate: function fileValidate(input, validizr, event) {
				var $input = $(input),
				filename = $(input).val(),
				maxsize = $input.data('max-size') || 100000, //100mb
				filerror = $input.data('error-message') || 'Archivo demasiado pesado',
				textcontainer = $input.parents('.form-control').find('[data-role="file-text"]'),
				prevtext = $(textcontainer).text();

				if ($input.val()) {
					var filesize = $input.get(0).files[0].size / 1028;
				} else {
					var filesize = false;
				}

				//define el limite de tamaño
				if (filesize) {
					if (maxsize) {
						maxsize = maxsize;
						// console.log('limit defined:' + maxsize);
					}

					if (filesize > maxsize) {
						textcontainer.html(filerror);
						return false;
					} else {
						// console.log('just right');
						if (filename.substring(3, 11) == 'fakepath') {
							filename = filename.substring(12);
						}
						if (!filename) {
							filename = textcontainer.text();
						}
						textcontainer.html(filename);
						return true;
					}
				} else {
					if (!$input.prop('required')) {
						textcontainer.html(prevtext);
						return true;
					} else {
						textcontainer.html(prevtext);
						return false;
					}
				}
			} } };



	$.fn.commonForm = function () {
		if (this.data('commonForm')) {
			return this.data('commonForm');
		}
		return this.each(function (i, el) {
			$(el).data('commonForm', new CommonForm(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="common-form"]').commonForm();
	});
})(window, document, jQuery);
'use strict';$(document).ready(function () {

  $('body').on('click', '#btn-form-message', function () {
    var formData = $('#admision-message').serializeArray();
    formData.push({ name: 'action', value: 'form-ajax-nonce' });
    formData.push({ name: 'security', value: $('#form-ajax-nonce').val() });
    formData.push({ name: 'message', value: tmce_getContent('tiny') });


    $('#btn-form-message').addClass('button--loading');

    $.post(data.base_url + 'message', $.param(formData), function (json) {

      json = JSON.parse(json);

      if (json.code == 422) {
        for (input in json.data) {
          $('[name=' + input + ']').addClass('invalid-input').parents('.form-control').attr('data-error-message', json.data[input]).addClass('form-control--invalid');
          $('[name=' + input + ']').siblings('.form-control__text').hide();
          removeClass($('[name=' + input + ']'));
        }
      }

      if (json.code == 200) {
        $('#msj_message').html('<div class="message message--ghost-success" data-module="message"> <div class="message__body"> <p>' + json.msg + '</p> </div> <button class="message__close-button" data-role="close"></button> </div> ');
        $('#admision-message')[0].reset();
      }

      if (json.code == 500) {
        $('#msj_message').html('<div class="message message--ghost-danger" data-module="message"> <div class="message__body"> <p>' + json.msg + '</p> </div> <button class="message__close-button" data-role="close"></button> </div>');
      }

      setTimeout(function () {
        $('#msj_message .message').remove();
      }, 4000);

      $('#btn-form-message').removeClass('button--loading');
    });
    return false;
  });


  function removeClass(input) {
    setTimeout(function () {
      input.siblings('.form-control__text').show(); //added
      input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
    }, 4000);
  }

  function tmce_getContent(editor_id, textarea_id) {
    if (typeof editor_id == 'undefined') editor_id = wpActiveEditor;
    if (typeof textarea_id == 'undefined') textarea_id = editor_id;

    if (jQuery('#wp-' + editor_id + '-wrap').hasClass('tmce-active') && tinyMCE.get(editor_id)) {
      return tinyMCE.get(editor_id).getContent();
    } else {
      return jQuery('#' + textarea_id).val();
    }
  }
});
'use strict';(function (window, document, $) {
	"use strict";

	var Message = function Message(element) {
		this.$element = $(element);
		this.$element.find('[data-role="close"]').on('click', this.close.bind(this));

		return this;
	};
	Message.prototype = {
		close: function close(event) {
			event.preventDefault();
			this.$element.slideUp({
				duration: 250,
				progress: function progress(promise, _progress, remainingTime) {
					var percent = 1 - _progress;
					$(this).css('opacity', percent);
				},
				complete: function complete() {
					$(this).remove();
				} });

		} };



	$.fn.message = function () {
		if (this.data('message')) {return this.data('message');}
		return this.each(function (i, el) {
			$(el).data('message', new Message(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="message"]').message();
	});
})(window, document, jQuery);
'use strict';(function (window, document, $) {
	"use strict";

	var Modal = function Modal(element) {
		this.$element = $(element);
		this.target = this.$element.data('target');
		this.method = this.$element.data('method') || 'GET';
		this.query = this.$element.data('query') || {};

		this.$element.on('click.modal', this.open.bind(this));
		return this;
	};
	Modal.prototype = {
		close: function close(event) {
			event.preventDefault();
			var $modal = $(event.currentTarget).parents('.modal');
			$modal.fadeIn({
				duration: 200, //chng
				complete: function complete() {
					$modal.remove();
				} });

		},
		open: function open(event) {
			event.preventDefault();

			var $element = this.$element;

			$element.trigger('modal.preopen', [this]);

			var lb_promise = this.showLightbox(),
			ajax_promise = $.ajax({
				url: this.target,
				method: this.method,
				data: this.query });


			$.when(lb_promise, ajax_promise).then(function (lb, ajax_res) {
				var $modal = lb,
				response = ajax_res[0];

				$modal.html(response);
				$modal.addClass('loaded');
				$element.trigger('modal.complete', [$modal, response]);
			});
		},

		showLightbox: function showLightbox() {
			var promise = new $.Deferred(),
			$modal = $('<div class="modal"><div class="modal__body" data-role="modal-body"><button data-role="modal-btn" class="modal__button"></button><div data-role="modal-content" class="modal__content"></div></div></div>');

			$modal.find('[data-role="modal-btn"]').on('click.modal', this.close.bind(this));
			$('body').append($modal);

			$modal.addClass('modal--loaded');

			// RESOLVE SEGUN DISPONIBILIDAD
			var ended = false;
			$modal.on('transitionend', function () {
				ended = true;
				promise.resolve($modal.find('[data-role="modal-content"]'));
			});

			setTimeout(function () {
				if (!ended) {
					ended = true;
					promise.resolve($modal.find('[data-role="modal-content"]'));
				}
			}, 200);


			return promise;
		} };



	$.fn.modal = function () {
		if (this.data('modal')) {return this.data('modal');}
		return this.each(function (i, el) {
			$(el).data('modal', new Modal(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="modal"]').modal();
	});
})(window, document, jQuery);
'use strict';var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};(function (window, document, $) {
   "use strict";

   var Breakpoints = {
      huge: '90rem',
      desktop: '80rem',
      large: '64rem',
      book: '56.25rem',
      medium: '50rem',
      tablet: '48rem',
      small: '40rem',
      phablet: '30rem',
      phone: '20rem' };


   var unique = function unique(arr) {
      var unique = [],
      i;

      for (i = 0; i < arr.length; i++) {
         var current = arr[i];
         if (unique.indexOf(current) < 0) {
            unique.push(current);
         }
      }
      return unique;
   };


   var MQChange = function MQChange() {
      if (typeof window.matchMedia === 'undefined') {
         console.log('Error: Window.matchMedia or polyfill is required');
         return;
      }
      this.setMedias();
   };

   MQChange.prototype = {
      registerMedia: function registerMedia(query, actions) {
         var registered_mq = window.matchMedia(query);
         var mq_actions = function mq_actions(mql) {
            // react to media query match
            if (mql.matches && typeof actions.match === 'function') {
               actions.match();
            }

            // react to media query unmatch
            else if (!mql.matches && typeof actions.unmatch === 'function') {
                  actions.unmatch();
               }
         };

         if ((typeof actions === 'undefined' ? 'undefined' : _typeof(actions)) === 'object') {
            registered_mq.addListener(mq_actions);
            mq_actions(registered_mq);
         }
      },

      setMedias: function setMedias() {
         var app = this;
         var $changeables = $('[data-mq-change]');

         for (var mqName in Breakpoints) {
            // closure para manejar la variable
            (function (mq_slug) {
               app.registerMedia('screen and (max-width: ' + Breakpoints[mq_slug] + ')', {
                  match: function match() {
                     app.moveElements($changeables.filter('[data-mq-change="' + mq_slug + '"]'), 'match');
                  },
                  unmatch: function unmatch() {
                     app.moveElements($changeables.filter('[data-mq-change="' + mq_slug + '"]'), 'unmatch');
                  } });

            })(mqName);
         }
      },

      moveElements: function moveElements($set, type) {
         var areaType = 'data-' + type + '-area',
         groups = $set.groupByAtt(areaType);

         groups.forEach(function ($group) {
            var $target = $('[data-area-name="' + $group.first().attr(areaType) + '"]');

            $group.sort(function (a, b) {
               return $(a).data('order') - $(b).data('order');
            });

            $group.appendTo($target);
         });
      } };



   $.fn.groupByAtt = function (attname) {
      var $set = this,
      groups = [],
      posibles = [];

      // se guardan todos los posibles valores
      $set.each(function (i, el) {
         posibles.push(el.getAttribute(attname));
      });

      // se quitan los elementos duplicados dejando solo los unicos
      posibles = unique(posibles);

      // se itera sobre las posibilidades y se agrupan los elementos
      posibles.forEach(function (value) {
         groups.push($set.filter('[' + attname + '="' + value + '"]'));
      });

      return groups;
   };

   // self initialization
   $(document).ready(function () {
      var changeable = new MQChange();
   });

})(window, document, jQuery);
'use strict';(function (window, document, $) {
   "use strict";

   var NavBar = function NavBar(element) {
      this.$navBar = $(element);
      this.$navBarBody = this.$navBar.find('[data-role="nav-body"]');
      this.$navBarDeployer = this.$navBar.find('[data-role="nav-deployer"]');
      this.$navBarDeployer.on('click.NavBar', this.toggleNavBar.bind(this));
      var offset = this.$navBar.data('offtop');
      var stopper = $(this.$navBar.data('stopper')).height();
      var status;

      if (stopper === undefined || stopper == false) {
         status = false;
      } else {
         status = true;
      }

      $(window).scroll(function () {
         var scroll = this.pageYOffset || document.documentElement.scrollTop;
         var scrollHeight = $(document).height();
         var scrollPosition = $(window).height() + $(window).scrollTop();
         // var scrollzero = (scrollHeight - scrollPosition) / scrollHeight;
         var scrollstop = scrollHeight - stopper;
         var stop = (scrollstop - scrollPosition) / scrollHeight;
         var returner;

         status == false ? returner = true : returner = stop > 0;

         if (scroll >= offset && returner == true) {
            $('body').addClass('scrolled');
            $('body').removeClass('no-scrolled');
         } else {
            $('body').addClass('no-scrolled');
            $('body').removeClass('scrolled');
         }
      });

      this.touchSubmenus();

      //WATCH
      this.$searchBarBody = $('body').find('[data-role="search-body"]');
      this.$searchBarDeployer = $('body').find('[data-role="search-deployer"]');
      this.$inputSearch = $('body').find('[name="s"]');
      this.$searchBarDeployer.on('click.NavBar', this.toggleExtra.bind(this));

      return this;
   };

   NavBar.prototype = {
      toggleNavBar: function toggleNavBar(event) {
         event.preventDefault();
         this.$navBarDeployer.toggleClass('deployed');
         this.$navBarBody.toggleClass('deployed');
         this.$inputSearch.focus();
         //WATCH
         $('body').toggleClass('deployed--nav').removeClass('scrolled');
         this.$searchBarDeployer.removeClass('deployed');
         this.$searchBarBody.removeClass('deployed');
         $('body').removeClass('deployed--search');
      },

      toggleExtra: function toggleExtra(event) {
         event.preventDefault();
         this.$searchBarDeployer.toggleClass('deployed');
         this.$searchBarBody.toggleClass('deployed').find('[id="busqueda"]').focus();
         $('body').toggleClass('deployed--search').removeClass('scrolled');

         this.$navBarDeployer.removeClass('deployed');
         this.$navBarBody.removeClass('deployed');
         $('body').removeClass('deployed--nav');
      },

      touchSubmenus: function touchSubmenus() {
         // if (!Modernizr.touchevents) {
         //    return;
         // }
         var $touchSubmenus = $('body').find('[data-role="touch-submenu"]');

         $touchSubmenus.on('click', '[data-role="touch-submenu-deployer"]', function (e) {
            event.preventDefault();
            // console.log('clicked');
            var $current = $(e.currentTarget),
            $currentParent = $current.parents('[data-role="touch-submenu"]');
            $current.toggleClass('deployed');
            $currentParent.toggleClass('deployed');
         });
      } };


   $.fn.navBar = function () {
      if (this.data('navBar')) {
         return this.data('navBar');
      }
      return this.each(function (i, el) {
         $(el).data('navBar', new NavBar(el));
      });
   };

   // self initialization
   $(document).ready(function () {
      $('[data-module="nav-bar"]').navBar();
   });

})(window, document, jQuery);
'use strict';$(document).ready(function () {
  $('body').on('click', '#form-shared-email .button', function () {
    var button = $(this);
    var formData = $('body').find('#form-shared-email').serializeArray();
    formData.push({ name: 'url', value: $('#btn-active-modal-emails').data('url') });
    formData.push({ name: 'title', value: $('#btn-active-modal-emails').data('title') });

    button.addClass('button--loading');

    $.post(data.base_url + 'shared-emails-post', $.param(formData), function (json) {
      json = JSON.parse(json);
      var input = [];
      console.log(json);
      if (json.code == 422) {
        for (input in json.data) {
          $('#form-shared-email [name=' + input + ']').addClass('invalid-input').parents('.form-control').attr('data-error-message', json.data[input]).addClass('form-control--invalid');
          $('#form-shared-email [name=' + input + ']').siblings('.form-control__text').hide();
          removeClass($('#form-shared-email [name=' + input + ']'));
        }
      }

      if (json.code == 200) {
        $('#section-form-shared-email').hide();
        $('#section-shared-email-exito').addClass('exito');
        $('#section-shared-email-exito').show();
      }

      button.removeClass('button--loading');
    });

    return false;
  });

  function removeClass(input) {
    setTimeout(function () {
      input.siblings('.form-control__text').show(); //added
      input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
    }, 4000);
  }
});
'use strict'; //////////////////////
////////////////////// Common Slider
//////////////////////
(function (window, document, $) {
	"use strict";

	// check for NinjaSlider dependency
	if (typeof NinjaSlider === 'undefined') {
		console.log('Error: NinjaSlider is required');
		return;
	}

	var CommonSlider = function CommonSlider(element) {
		this.container = element;
		this.$container = $(element);
		this.$slides = this.$container.find('[data-role="slider-slide"]');
		this.$arrows = this.$container.find('[data-role="slider-arrow"]');
		this.$bullets = this.$container.find('[data-role="slider-bullet"]');
		this.$thumbnails = this.$container.find('[data-role="slider-thumbnail"]');
		this.$footers = this.$container.find('[data-role="slider-footing"]');
		this.$transition = this.$container.data('transition') || false;
		this.$speed = this.$container.data('speed') || 400;
		this.$autotime = 2000;
		this.$slidelist = this.$container.find('[data-role="slider-list"]');

		if (typeof this.$transition !== 'undefined') {
			this.$autotime = this.$transition;
		}

		this.$slidelist.find('.slider__slide:first-child').addClass('current').attr('data-current', true);

		this.ninjaSlider = new NinjaSlider(this.container, {
			auto: this.$autotime,
			speed: this.$speed,
			transitionCallback: this.transitionCallback.bind(this) });


		this.$arrows.on('click.CommonSlider', this.arrowCallback.bind(this));
		this.$bullets.on('click.CommonSlider', this.bulletCallback.bind(this));
		this.$thumbnails.on('click.CommonSlider', this.bulletCallback.bind(this));
	};
	CommonSlider.prototype = {
		transitionCallback: function transitionCallback(index, slide, ninjaSlider) {
			if (this.$bullets.length) {
				this.$bullets.removeClass('slider__bullet--current');
				this.$bullets.filter('[data-target="' + index + '"]').addClass('slider__bullet--current');
			}

			if (this.$thumbnails.length) {
				this.$thumbnails.removeClass('slider__thumbnail--current');
				this.$thumbnails.filter('[data-target="' + index + '"]').addClass('slider__thumbnail--current');
			}

			if (this.$footers.length) {
				this.$footers.removeClass('slider__foot--current');
				this.$footers.filter('[data-target="' + index + '"]').addClass('slider__foot--current');
			}
			if (this.$slides.length) {
				this.$slides.removeClass('current').attr('data-current', false);
				this.$slides.filter('[data-index="' + index + '"]').addClass('current').attr('data-current', true);
			}
		},

		arrowCallback: function arrowCallback(event) {
			event.preventDefault();
			var $btn = $(event.currentTarget),
			direction = $btn.data('direction');

			this.ninjaSlider.reset();
			this.ninjaSlider[direction]();

			$('.slider__slide iframe').each(function () {
				var src = $(this).attr('src');
				$(this).attr('src', src);
			});
		},

		bulletCallback: function bulletCallback(event) {
			event.preventDefault();
			var $btn = $(event.currentTarget),
			target = $btn.data('target');

			this.ninjaSlider.reset();
			this.ninjaSlider.slide(target);
		} };


	$.fn.commonSlider = function () {
		if (this.data('commonSlider')) {return this.data('commonSlider');}
		return this.each(function (i, el) {
			$(el).data('commonSlider', new CommonSlider(el));
		});
	};

	// self initialization
	$(document).ready(function () {
		$('[data-module="slider"]').commonSlider();
	});
})(window, document, jQuery);
"use strict"; /*
               Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
              */
(function () {
   var b, f;
   b = window.jQuery;
   f = b(window);
   b.fn.stick_in_parent = function (d) {
      var A, w, J, n, B, K, p, q, k, E, t;
      null == d && (d = {});
      t = d.sticky_class;
      B = d.inner_scrolling;
      E = d.recalc_every;
      k = d.parent;
      q = d.offset_top;
      p = d.spacer;
      w = d.bottoming;
      null == q && (q = 0);
      null == k && (k = void 0);
      null == B && (B = !0);
      null == t && (t = "is_stuck");
      A = b(document);
      null == w && (w = !0);
      J = function J(a, d, n, C, F, u, r, G) {
         var v, _H, m, D, I, c, g, x, y, z, h, l;
         if (!a.data("sticky_kit")) {
            a.data("sticky_kit", !0);
            I = A.height();
            g = a.parent();
            null != k && (g = g.closest(k));
            if (!g.length) throw "failed to find stick parent";
            v = m = !1;
            (h = null != p ? p && a.closest(p) : b("<div />")) && h.css("position", a.css("position"));
            x = function x() {
               var c, f, e;
               if (!G && (I = A.height(), c = parseInt(g.css("border-top-width"), 10), f = parseInt(g.css("padding-top"), 10), d = parseInt(g.css("padding-bottom"), 10), n = g.offset().top + c + f, C = g.height(), m && (v = m = !1, null == p && (a.insertAfter(h), h.detach()), a.css({
                  position: "",
                  top: "",
                  width: "",
                  bottom: "" }).
               removeClass(t), e = !0), F = a.offset().top - (parseInt(a.css("margin-top"), 10) || 0) - q,
               u = a.outerHeight(!0), r = a.css("float"), h && h.css({
                  width: a.outerWidth(!0),
                  height: u,
                  display: a.css("display"),
                  "vertical-align": a.css("vertical-align"),
                  "float": r }),
               e)) return l();
            };
            x();
            if (u !== C) return D = void 0, c = q, z = E, l = function l() {
               var b, l, e, k;
               if (!G && (e = !1, null != z && (--z, 0 >= z && (z = E, x(), e = !0)), e || A.height() === I || x(), e = f.scrollTop(), null != D && (l = e - D), D = e, m ? (w && (k = e + u + c > C + n, v && !k && (v = !1, a.css({
                  position: "fixed",
                  bottom: "",
                  top: c }).
               trigger("sticky_kit:unbottom"))), e < F && (m = !1, c = q, null == p && ("left" !== r && "right" !== r || a.insertAfter(h),
               h.detach()), b = {
                  position: "",
                  width: "",
                  top: "" },
               a.css(b).removeClass(t).trigger("sticky_kit:unstick")), B && (b = f.height(), u + q > b && !v && (c -= l, c = Math.max(b - u, c), c = Math.min(q, c), m && a.css({
                  top: c + "px" })))) :
               e > F && (m = !0, b = {
                  position: "fixed",
                  top: c },
               b.width = "border-box" === a.css("box-sizing") ? a.outerWidth() + "px" : a.width() + "px", a.css(b).addClass(t), null == p && (a.after(h), "left" !== r && "right" !== r || h.append(a)), a.trigger("sticky_kit:stick")), m && w && (null == k && (k = e + u + c > C + n), !v && k))) return v = !0, "static" === g.css("position") && g.css({
                  position: "relative" }),

               a.css({
                  position: "absolute",
                  bottom: d,
                  top: "auto" }).
               trigger("sticky_kit:bottom");
            }, y = function y() {
               x();
               return l();
            }, _H = function H() {
               G = !0;
               f.off("touchmove", l);
               f.off("scroll", l);
               f.off("resize", y);
               b(document.body).off("sticky_kit:recalc", y);
               a.off("sticky_kit:detach", _H);
               a.removeData("sticky_kit");
               a.css({
                  position: "",
                  bottom: "",
                  top: "",
                  width: "" });

               g.position("position", "");
               if (m) return null == p && ("left" !== r && "right" !== r || a.insertAfter(h), h.remove()), a.removeClass(t);
            }, f.on("touchmove", l), f.on("scroll", l), f.on("resize",
            y), b(document.body).on("sticky_kit:recalc", y), a.on("sticky_kit:detach", _H), setTimeout(l, 0);
         }
      };
      n = 0;
      for (K = this.length; n < K; n++) {d = this[n], J(b(d));}
      return this;
   };
})(window, document, jQuery);
'use strict'; /* eslint-disable no-warning-comments */
/* eslint-disable wrap-iife */
/* eslint-disable space-before-function-paren */
/* eslint-disable camelcase */
(function (window, document, $) {
  'use strict';
  var DEBUG = true;
  var $window = $(window),
  $document = $(document),
  $body = $('body'),
  $mainNav,$mainHeader,
  isMobile = 'false';

  var LARGE_DOWN = 'screen and (max-width: 1024px)',
  MEDIUM_DOWN = 'screen and (max-width: 800px)',
  TABLET_DOWN = 'screen and (max-width: 768px)',
  SMALL_DOWN = 'screen and (max-width: 640px)',
  PHABLET_DOWN = 'screen and (max-width: 480px)',
  NADA_DOWN = 'screen and (max-width: 1px)',
  LARGE_SIZE = 1024,
  MEDIUM_SIZE = 800,
  TABLET_SIZE = 768,
  SMALL_SIZE = 640,
  PHABLET_SIZE = 480;

  var throttle = function throttle(fn) {
    return setTimeout(fn, 1);
  };

  var mqMap = function mqMap(mq) {
    var MQ = '';

    switch (mq) {
      case 'large-down':
        MQ = LARGE_DOWN;
        break;
      case 'medium-down':
        MQ = MEDIUM_DOWN;
        break;
      case 'tablet-down':
        MQ = TABLET_DOWN;
        break;
      case 'small-down':
        MQ = SMALL_DOWN;
        break;
      case 'phablet-down':
        MQ = PHABLET_DOWN;
        break;
      case 'nada-down':
        MQ = NADA_DOWN;
        break;}


    return MQ;
  };

  var normalize = function () {
    var from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
    to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc",
    mapping = {};

    for (var i = 0, j = from.length; i < j; i++) {
      mapping[from.charAt(i)] = to.charAt(i);}

    return function (str) {
      var ret = [];
      for (var i = 0, j = str.length; i < j; i++) {
        var c = str.charAt(i);
        if (mapping.hasOwnProperty(str.charAt(i))) {
          ret.push(mapping[c]);
        } else {
          ret.push(c);
        }
      }
      return ret.join('');
    };
  }();

  // TODO: watch
  // String.prototype.capitalize = function() {
  // 	return this.charAt(0).toUpperCase() + this.substring(1).toLowerCase();
  // }

  // APP
  var App = function App() {
    this.path = $('body').attr("data-path");
    this.ajaxURL = '/wp-admin/admin-ajax.php';
    this.loadLegacyAssets();

    var app = this;
  };

  App.prototype = {
    // TODO:
    // Starting settings
    onReady: function onReady() {
      this.setGlobals();
      this.autoHandleEvents($('[data-func]'));
      this.handleMobileTables();
      this.initTextCounter();
      this.initAreaResizer();
      this.conditionalInits();
      this.stickyParent();
      this.datacalendar_es();
      this.datacalendar_en();
      this.isMobile();
      this.deviceCity();
      this.initCleanSpace();
      this.initValidFile();
      this.initSubmitOnChange();
      this.objectFit();
      this.tablepress();
      this.menuShowMobileControl();
      this.toggleTarget();
      this.toggleTargetClass();
    },
    onLoad: function onLoad() {
      var app = this;

      $('[data-equalize="children"][data-mq="large-down"]').equalizeChildrenHeights(true, LARGE_DOWN);
      $('[data-equalize="children"][data-mq="medium-down"]').equalizeChildrenHeights(true, MEDIUM_DOWN);
      $('[data-equalize="children"][data-mq="tablet-down"]').equalizeChildrenHeights(true, TABLET_DOWN);
      $('[data-equalize="children"][data-mq="small-down"]').equalizeChildrenHeights(true, SMALL_DOWN);
      $('[data-equalize="children"][data-mq="phablet-down"]').equalizeChildrenHeights(true, PHABLET_DOWN);
      $('[data-equalize="children"][data-mq="nada-down"]').equalizeChildrenHeights(true, NADA_DOWN);
      $('[data-equalize="target"][data-mq="large-down"]').equalizeTarget(true, LARGE_DOWN);
      $('[data-equalize="target"][data-mq="medium-down"]').equalizeTarget(true, MEDIUM_DOWN);
      $('[data-equalize="target"][data-mq="tablet-down"]').equalizeTarget(true, TABLET_DOWN);
      $('[data-equalize="target"][data-mq="small-down"]').equalizeTarget(true, SMALL_DOWN);
      $('[data-equalize="target"][data-mq="phablet-down"]').equalizeTarget(true, PHABLET_DOWN);
      $('[data-equalize="target"][data-mq="nada-down"]').equalizeTarget(true, NADA_DOWN);

      if ($('[data-role="scroll-navigation"]').length) {
        this.scrollNavigation($('[data-role="scroll-navigation"]'));
      }

      if ($('[data-role="scroll-navigation-list"]').length) {
        this.scrollNavigationList($('[data-role="scroll-navigation-list"]'));
      }

      if (document.querySelector('[data-masonry-grid]')) {
        throttle(function () {
          app.masonry = new Masonry(document.querySelector('[data-masonry-grid]'), {
            itemSelector: '.masonry-item',
            percentPosition: true });

        });
      }

      $window.trigger('resize');
    },
    onResize: function onResize() {
      var app = this;
      throttle(function () {
        // app.setFixedHeader();
        $('[data-equalize="target"][data-mq="large-down"]').equalizeTarget(true, LARGE_DOWN);
        $('[data-equalize="target"][data-mq="medium-down"]').equalizeTarget(true, MEDIUM_DOWN);
        $('[data-equalize="target"][data-mq="tablet-down"]').equalizeTarget(true, TABLET_DOWN);
        $('[data-equalize="target"][data-mq="small-down"]').equalizeTarget(true, SMALL_DOWN);
        $('[data-equalize="target"][data-mq="phablet-down"]').equalizeTarget(true, PHABLET_DOWN);
        $('[data-equalize="target"][data-mq="nada-down"]').equalizeTarget(true, NADA_DOWN);
      });
    },
    onScroll: function onScroll() {
    },

    loadLegacyAssets: function loadLegacyAssets() {
      // voy a asumir que cualquier browser que no soporte <canvas> es un oldIE (IE8-)
      if (Modernizr.canvas) {
        return false;
      }
      Modernizr.load({
        load: this.path + 'scripts/support/selectivizr.min.js' });

    },

    autoHandleEvents: function autoHandleEvents($elements) {
      if (!$elements || !$elements.length) {
        return false;
      }
      var self = this;
      $elements.each(function (i, el) {
        var func = el.getAttribute('data-func') || false,
        evts = el.getAttribute('data-events') || 'click.customStuff';
        if (func && typeof self[func] === 'function') {
          $(el).
          off(evts).
          on(evts, $.proxy(self[func], self));
        }
      });
    },

    setEnquire: function setEnquire() {
      var app = this,
      $mutable = $('[data-mutable]');

      enquire.register(LARGE_DOWN, [{
        match: function match() {
          app.moveElements($mutable.filter('[data-mutable="large-down"]'), 'mobile');
        },
        unmatch: function unmatch() {
          app.moveElements($mutable.filter('[data-mutable="large-down"]'), 'desktop');
        } }]);


      enquire.register(TABLET_DOWN, [{
        match: function match() {
          app.moveElements($mutable.filter('[data-mutable="tablet-down"]'), 'mobile');
        },
        unmatch: function unmatch() {
          app.moveElements($mutable.filter('[data-mutable="tablet-down"]'), 'desktop');
        } }]);


      enquire.register(PHABLET_DOWN, [{
        match: function match() {
          app.moveElements($mutable.filter('[data-mutable="medium-down"]'), 'mobile');
        },
        unmatch: function unmatch() {
          app.moveElements($mutable.filter('[data-mutable="medium-down"]'), 'desktop');
        } }]);


      enquire.register(MEDIUM_DOWN, [{
        match: function match() {
          app.moveElements($mutable.filter('[data-mutable="small-down"]'), 'mobile');
        },
        unmatch: function unmatch() {
          app.moveElements($mutable.filter('[data-mutable="small-down"]'), 'desktop');
        } }]);


      enquire.register(MEDIUM_DOWN, [{
        match: function match() {
          app.moveElements($mutable.filter('[data-mutable="phablet-down"]'), 'mobile');
        },
        unmatch: function unmatch() {
          app.moveElements($mutable.filter('[data-mutable="phablet-down"]'), 'desktop');
          $('[data-role="nav-body"]').removeClass('deployed').removeAttr('style');
        } }]);


      // para qeu todo funcione bien en movil
      // se gatilla el evento resize en window
      $window.trigger('resize');
    },

    conditionalInits: function conditionalInits($context) {
      if (!$context) {
        $context = $document;
      }
      // delegaciones directas
      if ($context.find('[data-func]').length) {
        this.autoHandleEvents($context.find('[data-func]'));
      }

      if ($('[data-func="stickyheader"]').length) {
        this.stickyheader($('[data-func="stickyheader"]'));
      }

      if ($('[data-role="videothumb"]').length) {
        this.videohide($('[data-role="videothumb"]'));
      }

      // si no reconoces matchmedia no mereces enquire
      if (window.matchMedia) {
        this.setEnquire();
      }

    },

    setGlobals: function setGlobals() {
      $body = $('body');
      $mainHeader = $('#main-header');
      $mainNav = $('#main-nav');
      if ($mainNav.length) {
        this.navPos = $mainNav.offset().top;
      }
    },

    debug: function debug(message) {
      DEBUG && console.log(message);
    },

    moveElements: function moveElements($set, type) {
      var areaType = 'data-' + type + '-area',
      groups = $set.groupByAtt(areaType);

      groups.forEach(function ($group) {
        var $target = $('[data-area-name="' + $group.first().attr(areaType) + '"]');

        $group.sort(function (a, b) {
          return $(a).data('order') - $(b).data('order');
        });

        $group.appendTo($target);
      });
    },

    // FUNC:

    mapSectionsPositions: function mapSectionsPositions($items) {
      var map = [];
      $items.each(function (index, el) {
        var $el = $(el),
        $target = $($el.attr('href')),
        targetOffset = $target.offset();

        targetOffset.bottom = targetOffset.top + $target.height();

        map.push({
          $item: $el,
          offset: targetOffset,
          selector: $el.attr('href') });

      });

      return map;
    },

    listSectionsPositions: function listSectionsPositions($items) {
      var map = [];
      $items.each(function (index, el) {
        var $el = $(el),
        $target = $($el.children().attr('href')),
        targetOffset = $target.offset();

        if (typeof $target.val() !== 'undefined') {

          targetOffset.bottom = targetOffset.top + $target.height();

          map.push({
            $item: $el,
            offset: targetOffset,
            selector: $el.children().attr('href') });

        }
      });

      return map;
    },

    setFixedHeader: function setFixedHeader() {
      if (Modernizr.mq(VERTICAL_TABLETS_DOWN)) {
        var headerHeight = document.querySelector('#main-header').offsetHeight;
        document.body.style.marginTop = headerHeight + 14 + 'px';
      } else {
        document.body.style.marginTop = 0;
      }
    },

    blockScroll: function blockScroll(event) {
      event.stopPropagation();
    },

    // GENERAL

    handleMobileTables: function handleMobileTables() {
      $('.regular-content-area table').each(function (i, table) {
        $(table).wrap('<div class="regular-content-table-holder"></div>');
      });
    },

    setLightBox: function setLightBox(classes) {
      /// se crean los elementos
      var $bg = $('<div />').attr({
        id: 'lightbox-background',
        class: 'lightbox-background' }),

      $scrollable = $('<div />').attr({
        class: 'lightbox-scrollable-holder' }),

      $holder = $('<div />').attr({
        class: 'lighbox-holder' }).
      append('<div class="lightbox-close-holder"></div>'),
      $content = $('<div />').attr({
        class: 'lightbox-content' }),

      $closeBtn = $('<button class="primary-btn small-btn icon-btn--close-lb"></button>');

      // se inicia la promesa
      var promise = new $.Deferred();

      if (classes) {
        $holder.addClass(classes);
      }
      $closeBtn.on('click', this.closeLightBox);

      $holder.appendTo($scrollable).find('.lightbox-close-holder').append($closeBtn);

      $body.append($bg);

      $bg.animate({
        opacity: 1 }).
      promise().then(function () {
        $body.css('overflow', 'hidden');
        $bg.append($scrollable);
        $holder.append($content);
        promise.resolve($bg, $content);
        $bg.off();
      });

      return promise;
    },

    scrollNavigation: function scrollNavigation($nav) {
      var app = this,
      $navItems = $nav.children(),
      locationsMap = this.mapSectionsPositions($navItems);

      $window.on('resize.ScrollNav', function () {
        locationsMap = app.mapSectionsPositions($navItems);
      });

      $window.on('scroll.ScrollNav', function () {
        var scrollPosition = $window.scrollTop();

        locationsMap.forEach(function (item_info) {
          if (scrollPosition > item_info.offset.top - 100) {
            $navItems.removeClass('current');
            item_info.$item.addClass('current');
          }
        });
      });
    },

    scrollToTarget: function scrollToTarget(event) {
      event.preventDefault();

      var $item = $(event.currentTarget),
      target = $item.attr('href') || $item.data('target');

      if (!$(target).length) {
        return;
      }

      $('html, body').animate({
        scrollTop: $(target).offset().top });

    },

    scrollNavigationList: function scrollNavigationList($nav) {
      var app = this,
      $navItems = $nav.children(),
      locationsMap = this.listSectionsPositions($navItems);

      $window.on('resize.ScrollNav', function () {
        locationsMap = app.listSectionsPositions($navItems);
      });

      $window.on('scroll.ScrollNav', function () {
        var scrollPosition = $window.scrollTop();

        locationsMap.forEach(function (item_info) {
          if (scrollPosition > item_info.offset.top - 100) {
            $navItems.removeClass('current');
            item_info.$item.addClass('current');
          }
        });
      });
    },

    loadModal: function loadModal(event) {
      event.preventDefault();

      var app = this,
      $item = $(event.currentTarget),
      lightbox_promise = this.setLightBox('programa-detail'),
      ajax_promise = $.ajax({
        url: $item.data('target'),
        method: $item.data('method') || 'GET',
        data: $item.data('query') || {} });


      $.when(lightbox_promise, ajax_promise).then(function (lightbox_info, ajax_response) {
        var $lightbox_bg = lightbox_info[0],
        $lightbox_content = lightbox_info[1],
        response = ajax_response[0];

        $lightbox_content.append(response);

        throttle(function () {
          $lightbox_bg.addClass('loaded');
        });

      }).fail(function () {
        app.debug('fallo algo en el ajax');
        app.closeLightBox();
      });
    },

    getShareCount: function getShareCount($elements) {
      // se setea el api de google plus primero
      // api key publico
      // if( typeof gapi !== 'undefined' ){
      //     gapi.client.setApiKey('AIzaSyCKSbrvQasunBoV16zDH9R33D88CeLr9gQ');
      // }

      $elements.each(function (index, element) {
        var type = element.getAttribute('data-type'),
        url = element.getAttribute('data-url'),
        jsonUrl = '',
        data = {};

        var params = {
          nolog: true,
          id: url,
          source: "widget",
          userId: "@viewer",
          groupId: "@self" };


        if (type === 'facebook') {
          jsonUrl = 'http://graph.facebook.com/';
          data.id = url;
        } else if (type === 'twitter') {
          // Url obsoleta.
          //jsonUrl = 'http://urls.api.twitter.com/1/urls/count.json';
          //data.url = url;
          return;
        } else if (type === 'linkedin') {
          jsonUrl = 'http://www.linkedin.com/countserv/count/share';
          data.format = 'jsonp';
          data.url = url;
        } else {
          // gapi.client.rpcRequest('pos.plusones.get', 'v1', params).execute(function(resp) {
          //     console.log('count:', resp.result.metadata.globalCounts.count);
          // });
        }

        $.ajax({
          method: 'GET',
          url: jsonUrl,
          data: data,
          dataType: 'jsonp' }).
        then(function (response) {
          var count = '';

          // se saca el valor de cada red segun lo que responda el API correspondiente
          if (type === 'facebook') {
            count = response.shares;
          } else if (type === 'twitter') {
            count = response.count;
          } else if (type === 'linkedin') {
            count = response.count;
          } else {

          } // google


          // prevencion de error en caso de false o undefined
          count = count ? count : 0;
          element.textContent = count;
        });
      });
    },

    calendarControl: function calendarControl(event) {
      event.preventDefault();

      var app = this;

      var $btn = $(event.currentTarget),
      $dataHolder = $btn.parents('[data-role="calendar-data"]'),
      $itemsHolder = $('[data-events-holder]'),
      $monthName = $('[data-role="calendar-month"]'),
      direction = $btn.data('direction'),
      month = $dataHolder.data('month'),
      year = $dataHolder.data('year'),
      filter = $dataHolder.data('filter');

      if (app.isLoading) {
        return;
      }

      app.isLoading = true;

      /// se debe indicar que se esta cargando, asumo estados estandar
      /// eso queire decir, opacity nomas
      $monthName.css('opacity', '0.2');
      $itemsHolder.css('opacity', '0.2');

      $.getJSON('/wp-json/st-rest/actividades', {
        direction: direction,
        month: month,
        year: year,
        filter: filter }).
      then(function (response) {
        $dataHolder.data('month', response.month_num);
        $dataHolder.data('year', response.year);

        $monthName.
        text(response.month_name + ' - ' + response.year).
        attr({
          'data-prev': response.prev,
          'data-next': response.next });


        $itemsHolder.html(response.items);

        $monthName.css('opacity', '1');
        $itemsHolder.css('opacity', '1');

        app.isLoading = false;
      });
    },

    deployTarget: function deployTarget(event) {
      event.preventDefault();

      var $item = $(event.currentTarget),
      target = $item.data('target'),
      $targetElem;

      if (!target) {
        console.warn('No se especificó un objetivo en el atributo "data-target":', target);
        return;
      }

      $targetElem = $(target);
      if (!$targetElem.length) {
        console.warn('El objetivo no fue encontrado o el atributo "data-target" no es un selector válido :', target);
        return;
      }

      $item.data('animating', true);

      if ($item.data('deployed')) {
        $targetElem.
        slideUp().promise().
        then(function () {
          $item.data({
            deployed: false,
            animating: false }).
          removeClass('deployed');

          $targetElem.removeClass('deployed');
        });
      } else {
        $targetElem.
        slideDown().promise().
        then(function () {
          $item.data({
            deployed: true,
            animating: false }).
          addClass('deployed');

          $targetElem.addClass('deployed');
        });
      }
    },

    deployMainNav: function deployMainNav(event) {
      event.preventDefault();

      var $btn = $(event.currentTarget),
      $nav = $('[data-role="nav-container"]'),
      $headerBody = $('[data-role="header-body"]');

      if ($btn.data('deployed')) {
        $btn.
        data('deployed', false).
        removeClass('deployed');

        $nav.removeClass('deployed');
        $headerBody.removeClass('deployed');
      } else {
        $btn.
        data('deployed', true).
        addClass('deployed');

        $nav.addClass('deployed');
        $headerBody.addClass('deployed');
      }
    },

    deployCollapsable: function deployCollapsable(event) {
      event.preventDefault();

      var $item = $(event.currentTarget),
      $targetElem = $item.parents('.collapsable').find('.collapsable-body');

      $item.data('animating', true);

      if ($item.data('deployed')) {
        $targetElem.
        slideUp().promise().
        then(function () {
          $item.data({
            deployed: false,
            animating: false }).
          removeClass('deployed');

          $targetElem.removeClass('deployed');
        });
      } else {
        $targetElem.
        slideDown().promise().
        then(function () {
          $item.data({
            deployed: true,
            animating: false }).
          addClass('deployed');

          $targetElem.addClass('deployed');
        });
      }
    },

    toggleTarget: function toggleTarget(event) {
      event.preventDefault();

      $(event.currentTarget.getAttribute('data-target')).toggleClass('deployed');

      // expansion para cuando quiero enfocar algo despues de mostrarlo
      if (event.currentTarget.getAttribute('data-focus')) {
        $(event.currentTarget.getAttribute('data-focus')).focus();
      }
    },
    toggleTargetClass: function toggleTargetClass(event) {
      event.preventDefault();

      $(event.currentTarget.getAttribute('data-target-class')).toggleClass('deployed');

      // expansion para cuando quiero enfocar algo despues de mostrarlo
      if (event.currentTarget.getAttribute('data-focus')) {
        $(event.currentTarget.getAttribute('data-focus')).focus();
      }
    },

    tabControl: function tabControl(event) {
      event.preventDefault();

      var $button = $(event.currentTarget),
      $target = $('[data-tab-name="' + $button.data('target') + '"]');

      $button.siblings().removeClass('active');
      $target.siblings().removeClass('active');

      throttle(function () {
        $button.addClass('active');
        $target.addClass('active');
      });
    },

    deployParent: function deployParent(event) {
      event.preventDefault();
      $(event.currentTarget).parents(event.currentTarget.getAttribute('data-parent')).toggleClass('deployed');
    },

    collapseControl: function collapseControl(event) {
      event.preventDefault();

      var $button = $(event.currentTarget);
      var $scopeFAQ = $button.closest(".horizon__contenido");
      var $target = $scopeFAQ.find('[data-target-name="' + $button.data('target') + '"]');
      var $parentCollapse = $(event.currentTarget).parent()[0];

      throttle(function () {
        $parentCollapse.classList.toggle('active');
        $button.toggleClass('active');
        $target.toggleClass('active');
      });
    },

    showTab: function showTab(event) {
      event.preventDefault();
      var $item = $(event.currentTarget);
      console.log($item);
      $('[data-tabname="' + $item.data('target') + '"]').addClass('active').siblings().removeClass('active');
      console.log($item);
      $item.addClass('active').siblings().removeClass('active');
      console.log($item);
    },

    tabCollapse: function tabCollapse(event) {
      event.preventDefault();
      var $button = $(event.currentTarget);
      var $target = $('[data-tabname="' + $button.data('target') + '"]');

      $button.toggleClass('active');
      $target.toggleClass('active');
      var $tabname = $('[data-tabname]');
      console.log($tabname.data);
      $tabname.each(function () {
        if ($tabname.data !== $button.data('target')) {
          $target.removeClass('active');
        }
      });
    },

    deployMobileSearch: function deployMobileSearch(event) {
      event.preventDefault();

      var $button = $(event.currentTarget),
      $searchBox = $('#mobile-search-holder');

      $button.toggleClass('deployed');
      $searchBox.toggleClass('deployed');
    },

    printPage: function printPage(event) {
      event.preventDefault();
      window.print();
    },

    // HELPERS

    stickyheader: function stickyheader($element) {
      var $navBar = $element,
      $top = $navBar.data('offset');

      $window.scroll(function () {
        var scroll = actualposition();
        if (scroll >= $top) {
          $navBar.addClass('sticker');
        } else {
          $navBar.removeClass('sticker');
        }
      });
    },

    videohide: function videohide($element) {
      var $video = $element,
      $hiddenvideos = $('[data-role="videothumb"]:hidden'),
      $container = $('[data-module="videohide"]'),
      $showatstart = $container.data('qant'),
      $btnhide = $('[data-role="hidevideos"]'),
      $btnshow = $('[data-role="loadvideos"]'),
      $total = $video.length;

      console.log('show');
      console.log($showatstart);

      $video.slice(0, $showatstart).show();
      $('[data-role="hidevideos"]').hide();

      $btnshow.click(function (e) {
        e.preventDefault();
        $hiddenvideos.show('slow');
        $(this).hide();
        $btnhide.show();
      });

      $btnhide.click(function (e) {
        e.preventDefault();
        $video.slice($showatstart, $total).hide('slow');
        $(this).hide();
        $btnshow.show();
      });
    },

    // SELF INIT
    // data-role="textcounter"
    // data-role="countdown"
    initTextCounter: function initTextCounter() {
      $('[data-textcounter]').keyup(function (e) {
        var $textarea = $(this),
        maxlength = parseInt($textarea.attr('maxlength')),
        valuelength = $textarea.val().length,
        countdown = $textarea.parent().find('[data-role="countdown"]');

        e.preventDefault();
        countdown.text(maxlength - valuelength);

      });
    },

    initAreaResizer: function initAreaResizer() {
      jQuery.each(jQuery('textarea[data-autoresize]'), function () {
        var offset = this.offsetHeight - this.clientHeight;
        var resizeTextarea = function resizeTextarea(el) {
          jQuery(el).css('height', 'auto').css('height', el.scrollHeight + offset);
        };
        jQuery(this).on('keyup input', function () {
          resizeTextarea(this);
        }).removeAttr('data-autoresize');
      });
    },

    initCleanSpace: function initCleanSpace() {
      $('[data-cleanspace]').on({
        keydown: function keydown(e) {
          if (e.which === 32) return false;
        },
        change: function change() {
          this.value = this.value.replace(/\s/g, "");
        } });

    },

    initValidFile: function initValidFile() {
      $('[data-validfile]:required').change(function (e) {
        var $input = $(this),
        filename = $(this).val(),
        $father = $input.parents('.form-control').find('.form-control--file'),
        $mother = $input.parents('.form-control'),
        maxsize = $input.data('max-size'),
        filesize = $input.get(0).files[0].size,
        $okmessage = $mother.find('.form-control__text').text(),
        $errormessage = $mother.data('error-message');

        e.preventDefault();
        console.log('filesize: ' + filesize);
        console.log('okmessage: ' + $okmessage);
        //define el limite de tamaño
        if (maxsize) {
          maxsize = maxsize;
          console.log('limit defined:' + maxsize);
        } else {
          maxsize = 100000; //100mb
          console.log('limit undefined:' + maxsize);
        }

        if (filesize > maxsize) {
          console.log('too heavy');
          $mother.find('.form-control__text').html($errormessage);
          return false;
        } else {
          console.log('just right');
          $mother.find('.form-control__text').hide();
          if (filename.substring(3, 11) == 'fakepath') {
            filename = filename.substring(12);
          }
          if (!filename) {
            filename = $father.find('.content__btn--file__desc').text();
          }
          $father.find('.content__btn--file__desc').html(filename);
          return true;
        }
      });
    },

    initSubmitOnChange: function initSubmitOnChange() {
      $('[data-onchange]').change(function (e) {
        var $input = $(this),
        $form = $input.parents('form');

        e.preventDefault();
        $form.submit();
      });
    },

    copyClipboard: function copyClipboard(event) {
      event.preventDefault();

      var $button = $(event.currentTarget),
      $target = $('[data-target-name="' + $button.data('target') + '"]'),
      $value = $target.val(),
      $textArea = document.createElement("textarea"),
      $okbtn = $('.copyboard-status'),
      $isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);

      $textArea.value = $value;
      document.body.appendChild($textArea);

      if ($isiOSDevice) {
        var editable = $textArea.contentEditable;
        var readOnly = $textArea.readOnly;

        $textArea.contentEditable = true;
        $textArea.readOnly = false;

        var range = document.createRange();
        range.selectNodeContents($textArea);

        var selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);

        $textArea.setSelectionRange(0, 999999);
        $textArea.contentEditable = editable;
        $textArea.readOnly = readOnly;
      } else {
        $textArea.select();
      }

      if (document.execCommand('copy')) {
        $okbtn.fadeIn(1500).addClass('ok');
        setTimeout(function () {
          $okbtn.fadeOut('slow').addClass('ok');
        }, 1500);
      } else {
        $okbtn.fadeIn(1500).addClass('error');
        setTimeout(function () {
          $okbtn.fadeOut('slow').removeClass('error');
        }, 1500);
      }

      document.body.removeChild($textArea);
      console.log('copied');
    },

    goToTop: function goToTop(event) {
      event.preventDefault();
      $('html, body').animate({
        scrollTop: 0 },
      800);
    },

    stickyParent: function stickyParent() {
      jQuery.each(jQuery('[data-sticky]'), function () {
        var $sticky = $(this);
        var $offset_top = $(this).data('offset_top');
        var options = {
          offset_top: $offset_top,
          recalc_every: 1 };

        $sticky.stick_in_parent(options);
      });
    },

    datacalendar_es: function datacalendar_es() {
      jQuery.each(jQuery('[data-calendar-es]'), function () {
        var $calendar = $(this);

        $.datepicker.regional['es'] = {
          closeText: 'Cerrar',
          prevText: '<Ant',
          nextText: 'Sig>',
          currentText: 'Hoy',
          monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
          monthNamesShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
          dayNames: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
          dayNamesShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Juv', 'Vie', 'Sáb'],
          dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
          weekHeader: 'Sm',
          dateFormat: 'dd/mm/yy',
          firstDay: 1,
          isRTL: false,
          showMonthAfterYear: false,
          yearSuffix: '' };


        $.datepicker.setDefaults($.datepicker.regional['es']);

        $calendar.datepicker({
          onSelect: function onSelect(d, i) {
            if (d !== i.lastVal) {
              $(this).change();
              $(this).attr('data-validizr-validity', 'true').addClass('valid-input').parent('.form-control').addClass('valid-control');
              $(this).removeClass('invalid-input').parent('.form-control').removeClass('invalid-control');
            }
          } });

      });
    },

    datacalendar_en: function datacalendar_en() {
      jQuery.each(jQuery('[data-calendar-en]'), function () {
        var $calendar = $(this);
        $calendar.datepicker();
      });
    },

    isMobile: function isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        // $('[data-check-mobile]').html('Mobile');
      } else {
          // $('[data-check-mobile]').html('Not mobile');
        }
    },

    deviceCity: function deviceCity() {
      var display = $window.width();

      if (display > TABLET_SIZE) {
        $('[data-check-mobile]').html('DESKTOP (mayor a 768px)');
        // console.log('desktop');
      } else if (display >= PHABLET_SIZE && display <= TABLET_SIZE) {
        $('[data-check-mobile]').html('TABLET (menor a 768px - mayor a 480px)');
        // console.log('tablet');
      } else if (display <= PHABLET_SIZE) {
        $('[data-check-mobile]').html('MOBILE (menor a 480px)');
        // console.log('mobile');
      }
    },

    objectFit: function objectFit() {
      if (!Modernizr.objectfit) {
        $('[data-objectFit]').each(function () {
          var $container = $(this),
          imgUrl = $container.find('img').prop('src');
          if (imgUrl) {
            $container.
            css('backgroundImage', 'url(' + imgUrl + ')').
            addClass('box__object-fit');
          }
        });
      }
    },

    tablepress: function tablepress() {
      jQuery.each(jQuery('table.tablepress'), function () {
        var $this = $(this),
        $btable_html = '<div class="single__table__scroll"><table class="tablepress">' + $this.html() + '</table></div>',
        $ftable_html = '<p class="single__table__message">Desliza para ver</p>',
        $block_html = $btable_html + $ftable_html;

        $this.replaceWith($block_html);
      });
    },

    menuShowMobileControl: function menuShowMobileControl() {
      var $buttons = document.querySelectorAll('#main-menu .menu-item.menu-item-has-children');

      var toggleSubmenu = function toggleSubmenu(event) {
        //event.preventDefault();
        var $target = event.target;
        var $submenu = $target.querySelector('.sub-menu');

        throttle(function () {
          $submenu.classList.toggle('deployed');
        });
      };var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {

        for (var _iterator = $buttons[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var $buttonMenu = _step.value;
          $buttonMenu.addEventListener('click', toggleSubmenu);
        }} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}
    } };


  var app = new App();
  $document.ready(function () {
    app.onReady && app.onReady();
  });
  $window.on({
    'load': function load() {
      app.onLoad && app.onLoad();
    } });


})(window, document, jQuery);

// ///////////////////////////////////////
// Plugins y APIS
// ///////////////////////////////////////
(function (window, $, undefined) {
  var $window = $(window);

  // pruebas personalizadas para modernizr
  Modernizr.addTest('device', function () {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  });


  var unique = function unique(arr) {
    var unique = [],
    i;

    for (i = 0; i < arr.length; i++) {
      var current = arr[i];
      if (unique.indexOf(current) < 0) {
        unique.push(current);
      }
    }
    return unique;
  };

  $.fn.svgfallback = function (callback) {
    if (Modernizr.svg) {
      return false;
    }

    return this.each(function () {
      this.src = this.getAttribute('data-svgfallback');
    });
  };

  $.fn.groupByAtt = function (attname) {
    var $set = this,
    groups = [],
    posibles = [];

    // se guardan todos los posibles valores
    $set.each(function (i, el) {
      posibles.push(el.getAttribute(attname));
    });

    // se quitan los elementos duplicados dejando solo los unicos
    posibles = unique(posibles);

    // se itera sobre las posibilidades y se agrupan los elementos
    posibles.forEach(function (value) {
      groups.push($set.filter('[' + attname + '="' + value + '"]'));
    });

    return groups;
  };

  $.fn.equalizeHeights = function (dinamic, mqException) {
    var items = this,
    eq_h = function eq_h($collection) {
      var heightArray = [];

      $collection.removeClass('height-equalized').height('auto');

      if (!mqException || !Modernizr.mq(mqException)) {
        $collection.each(function (i, e) {
          heightArray.push($(e).outerHeight());
        });
        $collection.css({
          height: Math.max.apply(Math, heightArray) }).
        addClass('height-equalized').attr('data-max-height', Math.max.apply(Math, heightArray));
      }
    };

    setTimeout(function () {
      eq_h(items);
    }, 0);

    if (dinamic) {
      $window.on('resize', function () {
        setTimeout(function () {
          eq_h(items);
        }, 10);
      });
    }
  };

  $.fn.equalizeChildrenHeights = function (dinamic, mqException) {
    return this.each(function (i, e) {
      if ($(e).parents('[data-override-eq="true"]').length) {
        return;
      }
      $(e).children().equalizeHeights(dinamic, mqException);
    });
  };

  $.fn.equalizeTarget = function (dinamic, mqException) {
    return this.each(function (index, box) {
      $(box).find($(box).data('eq-target')).equalizeHeights(dinamic, mqException);
    });
  };

  $.fn.equalizeGroup = function (attname, dinamic, mqException) {
    var groups = this.groupByAtt(attname);

    groups.forEach(function ($set) {
      $set.equalizeHeights(dinamic, mqException);
    });

    return this;
  };

  $.fn.random = function () {
    var randomIndex = Math.floor(Math.random() * this.length);
    return $(this[randomIndex]);
  };
})(undefined, jQuery);
"use strict";$(document).ready(function () {
  //
  // var posicionActual = 0;
  //
  // $(window).scroll(function(){
  //    scroll = $(this).scrollTop()>100;
  //    if (scroll) {
  //       $('.share').show('slow');
  //    }else if(scroll < posicionActual) {
  //       $('.share').hide('slow');
  //       console.log('retrocediendo');
  //    }else {
  //       $('.share').hide('slow');
  //    }
  //
  // });

  $('.programas .grid-item article').mouseenter(function (event) {
    $(event.currentTarget).find(".box__body").addClass("deployed");
  });
  $('.programas .grid-item article').mouseleave(function (event) {
    $(event.currentTarget).find(".box__body").removeClass("deployed");
  });

  $('.form-control__field--select').change(function () {
    var $this = $(this),
    value = $this.val();

    if (value !== '') {
      $this.addClass('active');
    } else {
      $this.removeClass('active');
    }
  });

  $('[data-module="collapse-body"]').hide();
  $('[data-action="collapse-deploy"]').click(function () {
    $(this).siblings('[data-module="collapse-body"]').slideToggle();
    $(this).toggleClass('active');
  });

  $('[data-role="switch-target"]').change(function () {
    var $this = $(this),
    value = $this.val(),
    $target = $($this.data('target'));
    $target.addClass('off');

    $.getJSON(data.base_url + 'curriculum', { term_name: value }).
    done(function (json_response) {
      var response = $.parseJSON(json_response);
      if (response.is_bilingual == 1) {
        $target.removeClass('off');
      }
    });
  });
});

$(document).ready(function (e) {
  function t(t) {
    e(t).bind("click", function (t) {
      t.preventDefault();
      e(this).parent().fadeOut();
    });
  }
  e(".dropdown-toggle").click(function () {
    var t = e(this).parents(".button-dropdown").children(".dropdown-menu").is(":hidden");
    e(".button-dropdown .dropdown-menu").hide();
    e(".button-dropdown .dropdown-toggle").removeClass("active");
    if (t) {
      e(this).parents(".button-dropdown").children(".dropdown-menu").toggle().parents(".button-dropdown").children(".dropdown-toggle").addClass("active");
    }
  });
  e(document).bind("click", function (t) {
    var n = e(t.target);
    if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-menu").hide();
  });
  e(document).bind("click", function (t) {
    var n = e(t.target);
    if (!n.parents().hasClass("button-dropdown")) e(".button-dropdown .dropdown-toggle").removeClass("active");
  });
});

$(document).ready(function () {
  $('.button-test').on('click', function () {

    //CAMBIAR $(this) por $button y $('#'+ $(this).attr('data-target')) por $target
    var $button = $(this),
    $target = $('[data-tab-name="' + $(this).attr('data-target') + '"]'); //attr('data-target') por data.('target')
    console.log($('#' + $(this).attr('data-target')));

    $("[data-nivel='" + $(this).attr('data-nivel') + "']").removeClass('active');
    $('#' + $(this).attr('data-target')).siblings().removeClass('active');

    if ($('#' + $(this).attr('data-target')).hasClass('active')) {
      $(this).removeClass('active');
    } else {
      $(this).addClass('active');
    }

    $('#' + $(this).attr('data-target')).toggleClass('active');

  });
});